import { event } from 'jquery';
import React from 'react';
import { connect } from 'react-redux';
import { analyticsClickEvent } from '../../../action/firebaseAnalytics/firebaseAnalytics';
import { GTMFieldInteraction } from '../../../utils/GtmDatalayer';
import Cookies from 'universal-cookie';
import { extractEmail } from '../../../utils/extractEmail';
import { PropTypes } from 'prop-types';
import { frontEndLogs } from '../../../action/logs/frontEndLogs';
import { handleAddressFiledValidation } from '../../../utils/helpers/addressFieldValidation';
import { updateErrorState } from '../../../utils/helpers/stateUpdaters';

function checkApplicationRequiredFieldInProps(allDetails,prevState,allDetailData,nextProps,showDev){
  if (allDetails[prevState.fieldname] === '' && allDetailData[prevState.fieldname] === '') {
    let stages = {}
    stages[prevState.fieldname] = 'This is Required';
    stages['stage'] = nextProps.stage;
    let inputValues = {}
    inputValues[prevState.fieldname] = '';
    //nextProps.saveApplicationDatas(inputValues)
    return {
      showDev,
      value: ''
    };
  }
}

function checkResidentialStatusValidation(allDetailData,allDetails,nextProps){
  if (allDetailData['Current_Residential_Status__c'] === 'Homeowner - no mortgage' || allDetailData['Current_Residential_Status__c'] === 'Living with parents/family') {
    if (allDetails['Fractional_Residential_Expense__c'] == 'Amount cannot be £0 if your Residential status is Homeowner - mortgaged or Tenant/Boarding' || allDetails['Fractional_Residential_Expense__c'] =='This is Required') {
      let stagesValues = {}
      stagesValues['Fractional_Residential_Expense__c'] = '';
      stagesValues['stage'] = nextProps.stage;
      nextProps.appvalidations(stagesValues);
      return {
        value: ''
      };
    }
  }
}

function applicationQuestionFieldValidationBasedOnPriority(nextProps,prevState){
  if (nextProps.amountRequested.split(',').join('').length > 0 || nextProps.amountRequested === '') {
    if (nextProps.priority === 3) {
      let showDev = prevState.showDev;
      showDev[prevState.fieldname] = true;
      const allDetails = Object.assign({}, ...nextProps.applicationValidation);
      const allDetailData = Object.assign({}, ...nextProps.saveApplicationData);
      //for Fractional_Residential_Expense__c validations
      let resultResidentialStatus = checkResidentialStatusValidation(allDetailData,allDetails,nextProps);
      if(resultResidentialStatus){
        return resultResidentialStatus;
       }

     let checkVerifiedResult =  checkApplicationRequiredFieldInProps(allDetails,prevState,allDetailData,nextProps,showDev);
     if(checkVerifiedResult){
      return checkVerifiedResult;
     }
    }
  }
}

function checkSortCodePropsValidation(nextProps,prevState){
  if (nextProps.prepopulateCondition === true) {
    const allDetailDatas = Object.assign({}, ...nextProps.saveApplicationData);
    if (allDetailDatas[prevState.fieldname] && prevState.prepopulateUpdate === true) {

      if (allDetailDatas[prevState.fieldname] != prevState.value) {
        let preValue = allDetailDatas[prevState.fieldname];
        if (prevState.fieldname === 'sortcode_bankaccount') {
          preValue = allDetailDatas[prevState.fieldname].replace(/(\d{2})(\d{2})(\d{2})/, "$1-$2-$3")
        }

        return {
          value: preValue,
          prepopulateUpdate: false
        };
      }
    }

  }
}

export class Input extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      input: {},
      req: {},
      errors: {
      },

      value: '',
      displayerrors: '',
      inputType: 'text',
      showValidation: this.props.showAppValidations,
      stages: this.props.stage,
      curvalue: '',
      showDevs: true,
      prepopulateUpdate: true,
      keyData: '',
      showDev: {

      },
      showInformation : '', 
      maxValue: '',
      fieldname: this.props.field_api_name,
      hideFieldList: [],
      maxLoanAmountRange: '',
      minLoanAmountRange: ''
    }
    this.inputRef = React.createRef();
    this.handleChange = this.handleChange.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.updateErrorState = updateErrorState.bind(this);
  }

  componentDidMount() {
    const cookie = new Cookies()
    this.initializeQuestionValues();
    this.determineInputType();
    this.initializeVisibilityAndStages();
    if (this.props.field_api_name === 'genesis__Loan_Amount__c') {
      this.props.threasholdFunc(this.props.threshold);
      this.setMaximumThresholdLimitForLoanAmount()
      this.setMaximumThresholdLimitForQuoteLoanAmount();
      let fieldValues = {}, stageValues = {};
      let purchaseTrackingId = window.location.href.includes('trackingId');
      const allDetailData = Object.assign({}, ...this.props.saveApplicationData);
      if (cookie.get('trackingId')) {
        purchaseTrackingId = cookie.get('trackingId')
      }  
      if(cookie.get('sourceURL')) {
        if((allDetailData[this.props.field_api_name] == null || allDetailData[this.props.field_api_name] == '' || allDetailData[this.props.field_api_name] == undefined) || 
        (cookie.get('loanAmount') == null || cookie.get('loanAmount') == '' || cookie.get('loanAmount') == undefined)) {           
        fieldValues['genesis__Loan_Amount__c'] = 'This is Required';
        stageValues['genesis__Loan_Amount__c'] = false;

          this.props.appvalidations(fieldValues);
          this.props.secondSectionValidationUpdate(stageValues)
          frontEndLogs('Loan amount field required validation in prepopulate value', false, 400, 'componentDidMount', { fieldValues, stageValues, 'loanAmount': cookie.get('loanAmount') });
        }
      }
      if(purchaseTrackingId && cookie.get('loanAmount') !== '' && cookie.get('loanAmount') !== undefined){
        let formatedLoanAmount = this.handleLoanAmount(cookie.get('loanAmount'));
          allDetailData[this.props.field_api_name] = formatedLoanAmount;
          this.setState({value: allDetailData[this.props.field_api_name]});
          this.props.saveApplicationDatas(allDetailData);
          this.props.getAmountRequested(formatedLoanAmount)
        setTimeout(() => {
          this.checkLoanAmountFieldvalidationInpurchasejourney();
        }, 500);
      }
      else if(!purchaseTrackingId){
      this.setQuoteLoanAmountInApplication();
      }
    }
    
    this.prepopulateFirstNameAndLastName();
    this.prepopulateEmailAndMobile()

    this.setMinimumThresholdLimitForIncome();
    this.setStateForFirstSectionValues();

    setTimeout(() => {
      this.validationForUserDetailsPrePopulatedData();
    }, 2100);
    this.updateErrorState(this.props.field_api_name,'');
    let stages = {};

    const fieldMappings = {
        'Current_Flat_No__c': 'flatAbode',
        'Current_House_Name__c': 'houseandBuildingName',
        'HouseNumber__c': 'houseandBuildingNumber',
        'Address_Line1__c': 'numberAndStreet',
        'Town__c': 'townOrCity',
        'Address_line2__c': 'addressLine2'
      };

    const fieldApiName = this.props.field_api_name;
      const cookieKey = fieldMappings[fieldApiName];

    if (cookieKey) {
      this.props.field_api_validations.forEach((src) => {
      if (cookie.get('sourceURL') && (cookie.get(cookieKey)?.length > src.flxMax_Value__c
            || cookie.get(cookieKey)?.length < src.flxMin_Value__c)) {
      
          if (src.flxType__c === 'Specify Length') {
            const errorMessage = src.flxError_Message__c;
            stages[fieldApiName] = errorMessage;
            stages['stage'] = this.props.stage;

            this.props.appvalidations(stages);
            this.updateErrorState(fieldApiName , errorMessage);

            const fieldValues = { [fieldApiName]: errorMessage };
            const stageValues = { [fieldApiName]: false };

            this.props.appvalidations(fieldValues);
            this.props.thirdSectionValidationUpdate(stageValues);
          } else if (cookie.get('sourceURL') && (cookie.get(cookieKey) == null || cookie.get(cookieKey) === '' || cookie.get(cookieKey)?.trim() === '')) {
            
            const errorMessage = src.flxError_Message__c; 
            stages[fieldApiName] = errorMessage;
            stages['stage'] = this.props.stage;

            this.props.appvalidations(stages);
            this.updateErrorState(fieldApiName , errorMessage);
          } else if (cookie.get('sourceURL') && cookie.get(cookieKey)) {
            const hasAlphabets = /[a-zA-Z]/.test(cookie.get(cookieKey));
            
            if (!hasAlphabets && !handleAddressFiledValidation(fieldApiName, cookie.get(cookieKey))) {
              const errorMessage = src.flxError_Message__c;
              stages[fieldApiName] = errorMessage;
              stages['stage'] = this.props.stage;

              this.props.appvalidations(stages);
              this.setState((prevState) => {
                return {
                  errors: {
                    ...prevState.errors,
                    [fieldApiName]: errorMessage
                  }
                }
              })

              const fieldValues = { [fieldApiName]: errorMessage };
              const stageValues = { [fieldApiName]: false };

              this.props.appvalidations(fieldValues);
              this.props.thirdSectionValidationUpdate(stageValues);
            }
          }
        }
      });
    }
  }

  initializeQuestionValues() {
    let questionValues = {};
    const previousFieldQuestionMap = {
      Previous_Flat_No__c: 'Previous Flat/Abode',
      Previous_House_Name__c: 'Previous House/Building Name',
      Previous_HouseNumber__c: 'Previous House/Building Number',
      Previous_Address_Line1__c: 'Previous Street',
      Previous_Address_Line2__c: 'Previous Address Line 2',
      Previous_Town__c: 'Previous Town/City',
      Previous_Postal_Code__c: 'Previous Postcode'
    };

    questionValues['field_api_name'] = this.props.field_api_name;
    questionValues['priority'] = this.props.priority;
    questionValues['stage'] = this.props.stage;

    if (questionValues['field_api_name'] && previousFieldQuestionMap[questionValues['field_api_name']]) {
      questionValues['field_question'] = previousFieldQuestionMap[questionValues['field_api_name']];
    } else {
      questionValues['field_question'] = this.props.field_question;
    }

    questionValues['validation'] = this.props.field_api_validations.length !== 0 ? 'yes' : 'no';
    this.props.questionSave(questionValues);
  }

  determineInputType() {
    const { field_type, field_api_name } = this.props;
    let targetType = '';

    if (field_type === 'Number') {
      targetType = 'number';
    } else if (field_type === 'Email') {
      targetType = 'email';
    } else if (field_type === 'Currency' || field_type === 'Text' || field_api_name === 'sortcode_bankaccount') {
      targetType = 'text';
    }

    if (targetType) {
      this.setState({ inputType: targetType });
    }

    let input = this.state.input;
    input[field_api_name] = '';
    this.setState({ input });
  }

  initializeVisibilityAndStages() {
    const { field_api_name, priority, stage } = this.props;
    let showDev = this.state.showDev;

    if (priority === 3) {
      showDev[field_api_name] = false;
      let stagesVal = {
        [field_api_name]: '',
        stage: stage
      };
      this.props.appvalidations(stagesVal);
    } else {
      showDev[field_api_name] = true;
    }
    this.setState({ showDev });
  }

  // To check show the loan amount validation message
  checkLoanAmountFieldvalidationInpurchasejourney = () => {
    try {
      const cookie = new Cookies();
      let fieldValues = {}, stageValues = {};
      if (!this.checkValueBeforePrePopulate('genesis__Loan_Amount__c', cookie.get('loanAmount'))) {
        if (this.props.field_api_validations !== '') {
          frontEndLogs('Loan amount field validation', false, 200, 'checkLoanAmountFieldvalidationInpurchasejourney', this.props.field_api_validations);
          analyticsClickEvent('loan_amount_field_validation', this.props.field_api_validations);
          const allUserData = Object.assign({}, ...this.props.saveApplicationData);
          this.props.field_api_validations.map((src) => {
            if (src.flxType__c === 'Contains') {
              let errorMessage = src.flxError_Message__c;
              if (errorMessage.includes('LOAN_AMOUNT')) {
                errorMessage = errorMessage.replace('LOAN_AMOUNT', allUserData['genesis__Loan_Amount__c'])
              }
              fieldValues['genesis__Loan_Amount__c'] = errorMessage;
              stageValues['genesis__Loan_Amount__c'] = false;
              this.props.appvalidations(fieldValues);
              this.props.secondSectionValidationUpdate(stageValues)
              frontEndLogs('Loan amount field validation prepopulate', false, 400, 'checkLoanAmountFieldvalidationInpurchasejourney', errorMessage);
            }
          })
        } 
      } else {
        fieldValues['genesis__Loan_Amount__c'] = '';
        stageValues['genesis__Loan_Amount__c'] = true;

        this.props.appvalidations(fieldValues);
        this.props.secondSectionValidationUpdate(stageValues)
        frontEndLogs('Loan amount field validation prepopulate successfully', false, 200, 'checkLoanAmountFieldvalidationInpurchasejourney');
      }
    } catch (error) {
      frontEndLogs('Catch Error', true, 400, 'checkLoanAmountFieldvalidationInpurchasejourney', error.message);
    }
  }


  setQuoteLoanAmountInApplication = async ()=>{
    let loanAmountFieldValues = {}, loanAmountstageValues = {};
    const urlParams = new URLSearchParams(window.location.search);
    const quoteLoanAmount = urlParams.get('loanAmt');    
    if (quoteLoanAmount) {
      await this.setMaximumThresholdLimitForLoanAmount();
      const allApplicationDetailData = Object.assign({}, ...this.props.saveApplicationData);
      let formatedQuoteLoanAmount = this.handleLoanAmount(quoteLoanAmount);
      if (this.checkValueBeforePrePopulate('genesis__Loan_Amount__c', quoteLoanAmount)) {
        allApplicationDetailData[this.props.field_api_name] = formatedQuoteLoanAmount;
        this.setState({ value: allApplicationDetailData[this.props.field_api_name] });
        this.props.saveApplicationDatas(allApplicationDetailData);
        this.props.getAmountRequested(formatedQuoteLoanAmount)
        loanAmountFieldValues['genesis__Loan_Amount__c'] = '';
        loanAmountstageValues['genesis__Loan_Amount__c'] = true;
        this.props.appvalidations(loanAmountFieldValues);
        this.props.secondSectionValidationUpdate(loanAmountstageValues)
        frontEndLogs('Quote loan amount set in application', false, 200, 'setQuoteLoanAmountInApplication', { formatedQuoteLoanAmount });
      }
    }
  }

  setStateForFirstSectionValues = () => {
    const allDetailData = Object.assign({}, ...this.props.saveApplicationData);
    const newState = {};

    Object.keys(allDetailData).forEach(key => {
      if (allDetailData[key]) {
        if (key === 'First_Name') {
          newState['firstName'] = allDetailData[key];
        } else if (key === 'Last_Name') {
          newState['lastName'] = allDetailData[key];
        } else if (key === 'Mobile_Number') {
          newState['phoneNo'] = allDetailData[key];
        } else if (key === 'Email_Address') {
          newState['email'] = allDetailData[key];
        }
      }
    });

    this.setState(newState, () => {
      this.validationForUserDetailsPrePopulatedData();
    });
  };

  validationForUserDetailsPrePopulatedData = () => {
    let fieldValues = {}, stageValues= {}
    let allUserDataDetails = Object.assign({}, ...this.props.saveApplicationData);

    const newState = {
      firstName: allUserDataDetails['First_Name'] || '',
      lastName: allUserDataDetails['Last_Name'] || '',
      email: allUserDataDetails['Email_Address'] || '',
      phoneNo: allUserDataDetails['Mobile_Number'] || ''
    };

    this.setState(newState, () => {
    this.validatePurchaseRedirectFields(allUserDataDetails,fieldValues,stageValues); 
    if((!this.props.editable && this.props.prepopulateStatus) || this.props.firstNameFlag) {
      fieldValues['First_Name'] = '';
      stageValues['First_Name'] = true;
    } 
    if((!this.props.editable && this.props.prepopulateStatus) || this.props.lastNameFlag) {
      fieldValues['Last_Name'] = '';
      stageValues['Last_Name'] = true;
    }
    if((!this.props.editable && this.props.prepopulateStatus) || this.props.emailFlag) {
      fieldValues['Email_Address'] = '';
      stageValues['Email_Address'] = true;
    }
    if((!this.props.editable && this.props.prepopulateStatus) || 
    this.props.mobileNumberFlag) {
      fieldValues['Mobile_Number'] = '';
      stageValues['Mobile_Number'] = true;
    }

    this.props.appvalidations(fieldValues);
    this.props.firstSectionValidationUpdate(stageValues)

    setTimeout(() => {
      if(allUserDataDetails['First_Name'] && (allUserDataDetails['First_Name'] == '' || allUserDataDetails['First_Name'] == null || allUserDataDetails['First_Name'] == undefined)){
        fieldValues['First_Name'] = 'This is Required';
        stageValues['First_Name'] = false;

      }
    }, 400);
  });
};

  validatePurchaseRedirectFields = (allUserDataDetails, fieldValues, stageValues) => {
    const { firstName, lastName, email, phoneNo } = this.state;
    const cookie = new Cookies();
    let purchaseRedirectToken = window.location.search.includes('redirectToken');
    if (cookie.get('sourceURL') && purchaseRedirectToken) {
      //from purchase url
      const confirmEmailAddress = allUserDataDetails['Confirm_Email_Address'] || '';
      if (!confirmEmailAddress || confirmEmailAddress.trim() === '') {
        fieldValues['Confirm_Email_Address'] = 'This is Required';
        stageValues['Confirm_Email_Address'] = false;
      }
      if (!email) {
        fieldValues['Email_Address'] = 'This is Required';
        stageValues['Email_Address'] = false;
      }

      if (!lastName) {
        fieldValues['Last_Name'] = 'This is Required';
        stageValues['Last_Name'] = false;
      }

      if (!firstName) {
        fieldValues['First_Name'] = 'This is Required';
        stageValues['First_Name'] = false;
      }

      if (!phoneNo) {
        fieldValues['Mobile_Number'] = 'This is Required';
        stageValues['Mobile_Number'] = false;
      }
    }
  }


  prepopulateFirstNameAndLastName = async ()=> {
    const cookie = new Cookies();
    let fieldValues = {}, stageValue = {};

    if (this.props.field_api_name === 'First_Name') {
      if(cookie.get('firstName')){
        const allUserDetailData = Object.assign({}, ...this.props.saveApplicationData);

        if(allUserDetailData['First_Name'] === undefined && this.checkValueBeforePrePopulate('First_Name',cookie.get('firstName'))){
          allUserDetailData[this.props.field_api_name] = cookie.get('firstName');
          await this.props.saveApplicationDatas(allUserDetailData);

          fieldValues['First_Name'] = '';
          stageValue['First_Name'] = true;

          this.props.appvalidations(fieldValues);
          this.props.firstSectionValidationUpdate(stageValue)
        }
      }
    }

    if (this.props.field_api_name === 'Last_Name') {
      if(cookie.get('lastName') !== '' && cookie.get('lastName') !== undefined){
        const allDetailData = Object.assign({}, ...this.props.saveApplicationData);

        if(allDetailData['Last_Name'] === undefined &&this.checkValueBeforePrePopulate('Last_Name',cookie.get('lastName'))){
          allDetailData[this.props.field_api_name] = cookie.get('lastName');
          this.props.saveApplicationDatas(allDetailData);

          fieldValues['Last_Name'] = '';
          stageValue['Last_Name'] = true;

          this.props.appvalidations(fieldValues);
          this.props.firstSectionValidationUpdate(stageValue)
        }
      }
    }
  }

  checkFirstNameAndLastNameLength = async (value)=> {
    let fieldValues = {}, stageValue = {};
    if (this.props.field_api_name === 'First_Name') {
      const allUserDetailData = [...this.props.saveApplicationData];

      if (value.endsWith("-") || value.endsWith("'")) {        
        value = value.slice(0, -1);
      }
      allUserDetailData[this.props.field_api_name] = value;
      this.props.saveApplicationDatas(allUserDetailData);
      
      if(allUserDetailData['First_Name'] !== undefined){
        allUserDetailData[this.props.field_api_name] = value;
        fieldValues['First_Name'] = '';
        stageValue['First_Name'] = true;
        if (value.length == 0) {
          fieldValues['First_Name'] = 'This is Required';
          stageValue['First_Name'] = false;
        } else if(value.length < 2 || value.length >   30){
          fieldValues['First_Name'] = 'Enter the first name between 2 to 30 characters';
          stageValue['First_Name'] = false;
        }
        const basicTitleRegex = /^(mr|ms|mrs|miss|dr|prof|rev|hon|sir|dame|lord|lady|capt|major|col|gen|lt|sgt|fr|rabbi|imam)\b/i;
        const newTitleRegex = /^(bishop|cardinal|baron|baroness|viscount|viscountess|marquess|marchioness|earl|countess|duchess|prince|king)\b/i;
        const titleRegex = new RegExp(`${basicTitleRegex.source}|${newTitleRegex.source}`, 'i');
        const titles = [
          'mr', 'ms', 'mrs', 'miss', 'dr', 'prof', 'rev', 'hon',
          'sir', 'dame', 'lord', 'lady', 'capt', 'major', 'col',
          'gen', 'lt', 'sgt', 'fr', 'rabbi', 'imam'
        ];
      if (titleRegex.test(value) && !(titles.includes(value.split(/['-]/)[0]?.toLowerCase()) &&/^([a-zA-Z]+)(['-])[a-zA-Z]+(?: [a-zA-Z]+)*$/.test(value))) {
        let errorValues = { ...this.state.errors };
          errorValues[this.props.field_api_name] = 'Titles (e.g., Mr, Ms, Dr, etc) are not allowed in the first name.';
          fieldValues[this.props.field_api_name] = 'Titles (e.g., Mr, Ms, Dr, etc) are not allowed in the first name.';
          fieldValues['stage'] = this.props.stage;
          stageValue['First_Name'] = false;
          this.setState((prevState)=>{
            return {
              errors:{
                ...prevState.errors,
                [this.props.field_api_name] : 'Titles (e.g., Mr, Ms, Dr, etc) are not allowed in the first name.'
              }
            }
          })
        } 
        fieldValues['stage'] = 0;
        this.props.appvalidations(fieldValues);
        this.props.firstSectionValidationUpdate(stageValue)
      }
    }

    if (this.props.field_api_name === 'Last_Name') {
      this.checkLastNameLength(value, stageValue, fieldValues);  
    }
  }

  checkLastNameLength = async (value, stageValue, fieldValues) => {
    let allUserDetailData = [...this.props.saveApplicationData];
    if (value.endsWith("-") || value.endsWith("'")) {
      value = value.slice(0, -1);
    }
    if (allUserDetailData['Last_Name'] !== undefined) {
      allUserDetailData[this.props.field_api_name] = value;
      fieldValues['Last_Name'] = '';
      stageValue['Last_Name'] = true;
      await this.props.saveApplicationDatas(allUserDetailData);
      if (value.length == 0) {
        fieldValues['Last_Name'] = 'This is Required';
        stageValue['Last_Name'] = false;
      } else if (value.length < 2 || value.length > 30) {
        fieldValues['Last_Name'] = 'Enter the last name between 2 to 30 characters';
        stageValue['Last_Name'] = false;
      }
      fieldValues['stage'] = 0;
      this.props.appvalidations(fieldValues);
      this.props.firstSectionValidationUpdate(stageValue)
    }
  }

  prepopulateEmailAndMobile = ()=> {
    const cookie = new Cookies();
    let fieldValues = {}, stageValue = {};

    if (this.props.field_api_name === 'Email_Address') {
      if(cookie.get('email')){
        const allUserDetails = Object.assign({}, ...this.props.saveApplicationData);

        if(allUserDetails['Email_Address'] === undefined && this.checkValueBeforePrePopulate('Email_Address',cookie.get('email')) && this.validateEmail(cookie.get('email'))){
          allUserDetails[this.props.field_api_name] = cookie.get('email');
          this.props.saveApplicationDatas(allUserDetails);

          fieldValues['Email_Address'] = '';
          stageValue['Email_Address'] = true;

          this.props.appvalidations(fieldValues);
          this.props.firstSectionValidationUpdate(stageValue)
        }
      }
    }

    if (this.props.field_api_name === 'Mobile_Number') {
      if(cookie.get('mobileNumber') !== '' && cookie.get('mobileNumber') !== undefined){
        const allUserData = Object.assign({}, ...this.props.saveApplicationData);

        if(allUserData['Mobile_Number'] == undefined  && this.checkValueBeforePrePopulate('Mobile_Number',cookie.get('mobileNumber'))){
          allUserData[this.props.field_api_name] = cookie.get('mobileNumber');
          this.props.saveApplicationDatas(allUserData);

          fieldValues['Mobile_Number'] = '';
          stageValue['Mobile_Number'] = true;

          this.props.appvalidations(fieldValues);
          this.props.firstSectionValidationUpdate(stageValue);
        }
      }
    }
  }

  checkValueBeforePrePopulate = (fieldName, value) => {
    switch(fieldName) {
      case 'First_Name':
        { 
          return this.checkFirstNameBeforePrePopulate(value);
        }
      case 'Last_Name':
        {
          const hasHyphen = value.includes("-");
            const hasApostrophe = value.includes("'");
      
            if ((value.slice(-1) === "-" || value.slice(-1) === "'") || 
              (hasHyphen && value.slice(-1) === "-") || 
              (hasApostrophe && value.slice(-1) === "'") ||
              value.startsWith("-") ||
              value.endsWith("-") ||
              value.startsWith("'") ||
              value.endsWith("'") ||
              (hasHyphen && hasApostrophe)) {
              return false;
            }
            if(value.length >= 2 && /^[a-zA-Z-'\s]+$/.test(value) && value.length <= 30) {
              return true;
            }
            return false;
          }
      case 'Email_Address':
        return ((extractEmail(value) != null) && value.length >= 1 && value.length <= 49);
      case 'Mobile_Number':
        return this.validationForMobileNumber(value);
      case 'genesis__Loan_Amount__c':
        if (this.state.maxLoanAmountRange !== null && this.state.maxLoanAmountRange !== '' &&
          this.state.minLoanAmountRange !== null && this.state.minLoanAmountRange !== '') {
          let maxLoanAmountRange = Number.parseInt(this.state.maxLoanAmountRange,10);
          let minLoanAmountRange = Number.parseInt(this.state.minLoanAmountRange,10);
          const isValid = (value >= minLoanAmountRange && value <= maxLoanAmountRange);
          frontEndLogs('Loan amount range in state', false, 200, 'checkValueBeforePrePopulate', { maxLoanAmountRange, minLoanAmountRange, value });
          return isValid;
        }
        return false;
    }
  }

  checkFirstNameBeforePrePopulate = (value) => {
    const basicTitleRegex = /^(mr|ms|mrs|miss|dr|prof|rev|hon|sir|dame|lord|lady|capt|major|col|gen|lt|sgt|fr|rabbi|imam)\b/i;
    const newTitleRegex = /^(bishop|cardinal|baron|baroness|viscount|viscountess|marquess|marchioness|earl|countess|duchess|prince|king)\b/i;
    const titleRegex = new RegExp(`${basicTitleRegex.source}|${newTitleRegex.source}`, 'i');
    const hasHyphen = value.includes("-");
    const hasApostrophe = value.includes("'");
    if (
      (value.slice(-1) === "-" || value.slice(-1) === "'") ||
      (hasHyphen && value.slice(-1) === "-") ||
      (hasApostrophe && value.slice(-1) === "'") ||
      value.startsWith("-") ||
      value.endsWith("-") ||
      value.startsWith("'") ||
      value.endsWith("'") ||
      (hasHyphen && hasApostrophe)) {
      return false;
    }

    const titles = [
      'mr', 'ms', 'mrs', 'miss', 'dr', 'prof', 'rev', 'hon',
      'sir', 'dame', 'lord', 'lady', 'capt', 'major', 'col',
      'gen', 'lt', 'sgt', 'fr', 'rabbi', 'imam'
    ];

    if (titleRegex.test(value) && !(titles.includes(value.split(/['-]/)[0]?.toLowerCase()) &&/^([a-zA-Z]+)(['-])[a-zA-Z]+(?: [a-zA-Z]+)*$/.test(value))) {
      return false;
    }

    if (value.length >= 2 && /^[a-zA-Z-'\s]+$/.test(value) && value.length <= 30 && !titleRegex.test(value)) {
      return true;
    }
    return false;
  }

  validationForMobileNumber = (value) => {
    if (value.length !== 11) {
      return false;
    } else if (!/^\d+$/.test(value)) {
      return false;
    } else if (value.substring(0, 2) !== '07') {
      return false;
    } else {
      return true;
    }
  }

  handleLoanAmount = (value) => {
    let finalValue;

    if (value.length !== 0) {
      if(value.toString().indexOf(".") >= 0){
        let decimalPosition = value.toString().indexOf(".");
        let leftSide = value.toString().substring(0, decimalPosition);
        let rightSide = value.toString().substring(decimalPosition);
        let replaceLeftSide=leftSide.replace(/\D/g, "").split(',').join('');
        rightSide = rightSide.substring(0, 3);
        if(rightSide.length===2){
          rightSide=rightSide+'0';
        }

      if(rightSide.length===1){
        rightSide='.00';
      }
      value=replaceLeftSide+rightSide;
      finalValue = value;

      }else{
        value = value.toString().replace(/\D/g, "").split(',').join('')+'.00';
        finalValue = value;
      }
    }

    return finalValue;
  }

  setMinimumThresholdLimitForIncome = () => {
    const fieldName = 'Total_Monthly_Income__c'

    if(this.props.field_api_name === fieldName){
      if (this.props.field_api_validations !== '') {
        this.props.field_api_validations.map((src) => {
          if (src.flxType__c === 'Minimum Range') {
            sessionStorage.setItem('minMonthlyIncome', src.flxMin_Value__c)
          }
        })
      }
    }
  }

  handleFocus(field){
    switch(field){
        case "First_Name":
        case "Last_Name":
        case "Mobile_Number":
        case "Email_Address":
        case "Confirm_Email_Address":
        case "flxFirst_Name__c":
        case "flxLast_Name__c":
        case "genesis__Loan_Amount__c":
        case "frequency":
        case "Loan_Term_Requested__c":
        case "Current_Address_Country__c":
        case "Address_Line1__c":
        case "Address_Line2__c":
        case "Town__c":
        case "Postal_Code__c":
        case "Current_Residential_Status__c":
        case "Previous_Address_C":
        case "Previous_Address_Line1__c":
        case "Previous_Address_Line2__c":
        case "Previous_Town__c":
        case "Previous_Postal_Code__c":
        case "Total_Monthly_Income__c":
        case "Fractional_Residential_Expense__c":
        case "monthly_expense_financial_commitments":
        case "Fractional_Living_Expense__c":
        case "Total_Monthly_Expenses__c":
        case "flxNumber_of_Other_Financial_Dependents__c":
        case "Employment_Stability__c":
        case "occupation":
        case "sortcode_bankaccount":
        case "genesis__bank_account_number__c":
            GTMFieldInteraction(this.props.field_label);
            break;
    }
  }

  onFocus = (e) =>{
    this.handleFocus(e.target.name);
    if (e.target.name === "sortcode_bankaccount" || e.target.name === "occupation") {
      e.target.setAttribute('autoComplete', 'off');
    } else {
      e.target.setAttribute('autoComplete', 'nope');
    }
  }




  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.firstSectionSteps) {
      Input.handleElementFocus(nextProps);
    }

    if (prevState.value !== nextProps.field_value && nextProps.initialLoad === false) {
      return {
        value: nextProps.field_value
      };
    }

    if (Input.shouldUpdateValidation(nextProps, prevState)) {
      return { showValidation: nextProps.showAppValidations };
    }
    let checkNextPropsResult = applicationQuestionFieldValidationBasedOnPriority(nextProps,prevState);
    if(checkNextPropsResult){
      return checkNextPropsResult;
    }

    let checkSortCodePropsResult = checkSortCodePropsValidation(nextProps,prevState);
    if(checkSortCodePropsResult){
      return checkSortCodePropsResult;
    }
    return null;
  }

  static handleElementFocus(nextProps) {
    if (nextProps.isChangeMobile) {
      const inputElement = document.getElementById('Mobile_Number');
      if (inputElement) {
        inputElement.focus();
      }
    }

    if (nextProps.isChangeEmail) {
      const inputEmailElement = document.getElementById('Email_Address');
      if (inputEmailElement) {
        inputEmailElement.focus();
      }
    }
  }

  static shouldUpdateValidation(nextProps, prevState) {
    return (
      nextProps.showAppValidations !== prevState.showValidation &&
      (nextProps.showAppValidations !== '' || nextProps.stage === '2')
    );
  }

  handlRequiredFieldForNumberOfDependents = (src, errorValue, breakCondition) => {
    let stage = {};
    stage[this.props.field_api_name] = '';
    stage['stage'] = this.props.stage;
    if (src.flxType__c === 'Required Field') {
      if (this.state.input[this.props.field_api_name] === '') {
        errorValue[this.props.field_api_name] = 'This is Required';
        stage[this.props.field_api_name] = 'This is Required';
        stage['stage'] = this.props.stage;
        this.props.appvalidations(stage);
        this.setState({
          errors: errorValue
        });

        breakCondition = true;
      }
    }

    return breakCondition;
  }

  handleChangeForNumberOfDependents = (eventName) => {
    let breakCondition = false;
    let errorValue = {};
    errorValue[this.props.field_api_name] = '';
    let stage = {};
    stage[this.props.field_api_name] = '';
    stage['stage'] = this.props.stage;
    this.props.appvalidations(stage);
    if (this.props.field_api_validations !== '') {
      this.props.field_api_validations.map((src) => {
        if (this.state.inputType === "number" &&
            eventName == 'flxNumber_of_Other_Financial_Dependents__c'  && breakCondition === false) {
            let getUserInputValue = this.state.input[this.props.field_api_name].split(",").join("");

            breakCondition = this.handlRequiredFieldForNumberOfDependents(src, errorValue, breakCondition);

            if (src.flxType__c ==="Specify Length" || src.flxType__c ==="Specify Range" ) {
              if (getUserInputValue < src.flxMin_Value__c || getUserInputValue > src.flxMax_Value__c) {
                errorValue[this.props.field_api_name] = src.flxError_Message__c;
                stage[this.props.field_api_name] = src.flxError_Message__c;
                stage["stage"]= this.props.stage;
                this.props.appvalidations(stage);
                breakCondition = true;
              }
            }
          }
      })
    }
    this.setState((prevState) => {
      return {
        errors: {
          ...prevState.errors,
          [this.props.field_api_name]: errorValue[this.props.field_api_name]
        }
      }
    });
  }





 


 

  assignErrorMessage(errorVal, source, stages) {

    errorVal[this.props.field_api_name] = source.flxError_Message__c;
    stages[this.props.field_api_name] = source.flxError_Message__c;
    stages["stage"] = this.props.stage;
    this.props.appvalidations(stages);
    this.setState({
      errors: errorVal
    });
  }

  getFormattedCurrencyLength = (value) => {
    let updatedCurrentLength = 0;
    const formatedValues = (str) => {
      let cleanNumbers = str.replace(/\D/g, "");
      return cleanNumbers.split('').reverse().reduce((accumulator, digit, index) => {
        if (index > 0 && index % 3 === 0) {
          return digit + ',' + accumulator;
        }
        return digit + accumulator;
      }, '');
    };
    if (value.toString().indexOf(".") >= 0) {
      let decimal_pos = value.toString().indexOf(".");
      let left_side = value.substring(0, decimal_pos);
      let right_side = value.substring(decimal_pos);
      let replaceLeftSide = formatedValues(left_side);
      right_side = right_side.substring(0, 3);
      let concatValue = replaceLeftSide + right_side;
      updatedCurrentLength = concatValue.length;
    } else {
      let formattedValue = formatedValues(value);
      updatedCurrentLength = formattedValue.length;
    }
    return updatedCurrentLength;
  };

  handleChange(event) {

    let name = event.target.name;
    let value = event.target.value.trim();

    if (this.isInvalidMonthlyIncome(name, value, event)) {
      return;
    }

    if (name === 'flxFirst_Name__c' || name === 'First_Name' || name === 'flxLast_Name__c' || name === 'Last_Name') {
      const validatedName = this.handlenameValidation(event , value);
      if (validatedName === false) {
        return;
      }
      value = validatedName;
    } 

    // analyticsTypeEvent(name)
   this.setState({ showValidation: 'yes' });
    let Currentdatas = document.getElementById(this.props.field_api_name).value;
    let caret = event.target.selectionStart;
    const allDetailDatas = Object.assign({}, ...this.props.saveApplicationData);

    let currecyCurrentLength = '';

    // To test the handle change functionality
    currecyCurrentLength = this.CheckHandleChangeFunctionality(Currentdatas,name,value,allDetailDatas,currecyCurrentLength)

    const { Loan_Term_Requested__c } = allDetailDatas;
    if (event.target.name === 'genesis__Loan_Amount__c' && Loan_Term_Requested__c && Loan_Term_Requested__c !== '') {
      let stages = {};
      let stagesValues = {}
      let loanTermStagesValues = {}
      loanTermStagesValues['Loan_Term_Requested__c'] = '';
      stages['Loan_Term_Requested__c'] = 'This is Required';
      stagesValues['Loan_Term_Requested__c'] = false;
      stages['stage'] = this.props.stage;
      this.props.saveApplicationDatas(loanTermStagesValues);
      this.props.appvalidations(stages);
      this.props.secondSectionValidationUpdate(stagesValues);
      frontEndLogs('Loan term reset on loan amount change', true, 400, 'handleChange', { value, 'error': stages['Loan_Term_Requested__c']  });
    }

    // To validate the loan amount
    value = this.loanAmountValidation(event, value);

    if(this.isInvalidPostalOrMobile (name, value, event)) {
        return false;
    }


    this.setState({ showValidation: 'yes' });
    let input = this.state.input;
    input[event.target.name] = value;
    if (event.target.name !== 'flxPersonConfirmEmail__c') {
      let inputValues = {}
      inputValues[event.target.name] = value;
      this.props.saveApplicationDatas(inputValues)
    }

	const allData={...allDetailDatas,[event.target.name]:value};
    if (['Address_Line1__c', 'Town__c', 'Postal_Code__c', 'Address_Line2__c', 'Current_Flat_No__c', 'Current_House_Name__c', 'HouseNumber__c',].includes(event.target.name)) {
      const currentAddress = [allData.Current_Flat_No__c, allData.Current_House_Name__c, allData.HouseNumber__c, allData.Address_Line1__c, allData.Address_Line2__c, allData.Town__c, allData.Postal_Code__c].filter(Boolean).join(', ');
      this.props.saveApplicationDatas({ Current_Address_Country__c: currentAddress });
    }
    if (['Previous_Address_Line1__c', 'Previous_Town__c', 'Previous_Postal_Code__c', 'Previous_Address_Line2__c', 'Previous_Flat_No__c', 'Previous_House_Name__c', 'Previous_HouseNumber__c'].includes(event.target.name)) {
      const previousAddress = [allData.Previous_Flat_No__c, allData.Previous_House_Name__c, allData.Previous_HouseNumber__c, allData.Previous_Address_Line1__c, allData.Previous_Address_Line2__c, allData.Previous_Town__c, allData.Previous_Postal_Code__c].filter(Boolean).join(', ');
      this.props.saveApplicationDatas({ Previous_Address__C: previousAddress });
    }
    this.setState({
      input
    });

   let updatedCurrentLength = this.getFormattedCurrencyLength(value);

    if (this.props.field_type === 'Currency' && caret != 0) {
      caret = updatedCurrentLength - currecyCurrentLength + caret;

      console.log(caret)
    }


    if (event.target.name === 'genesis__Loan_Amount__c') {
      this.props.getAmountRequested(value);
    }

    this.handlingValidations();
  }

  updateCuruncyamount(value) {
    if (value.toString().indexOf(".") >= 0) {
      let decimal_pos = value.toString().indexOf(".");
      let left_side = value.substring(0, decimal_pos);
      let right_side = value.substring(decimal_pos);
      if(left_side){
      left_side = left_side.replace(/\D/g, "");
      let replaceLeftSide = left_side.split("").reverse().join("").match(/.{1,3}/g).join(",").split("").reverse().join("");
      return replaceLeftSide + right_side;
      }
    }
  }

  handlenameValidation(event, value) {

    let validInputRegex = /^[A-Za-z'-]*$/;
    if (!validInputRegex.test(value)) {
        return false;
    }
    value = this.firstLastNameValidation(event);
    const hyphenCount = value.split("-").length - 1;
    const apostropheCount = value.split("'").length - 1;
    if (hyphenCount > 1 || apostropheCount > 1) {
        return false;
    }

    const hasHyphen = value.includes("-");
    const hasApostrophe = value.includes("'");

    if ((value === "-" && hasHyphen) || (value === "'" && hasApostrophe)) {
        return false;
    }

    if ((value === "-" || value === "'") && value.slice(-1) === value) {
        return false;
    }

    if ((value === "'" && value.slice(-1) === "-") || (value === "-" && value.slice(-1) === "'")) {
        return false;
    }

    return value;

  }

  isInvalidMonthlyIncome(name, value, event) {
    if (name === "Total_Monthly_Income__c") {
      const numericValue = value.replace(/,/g, '');

      if (numericValue >= 20000 || Number.isNaN(numericValue) || numericValue.startsWith('0')) {
        event.preventDefault();
        return true;
      }
    }
    return false;
  }

  

  isInvalidPostalOrMobile(name, value, event) {
    if (this.props.field_api_name === 'flxPersonMobile__c' && value.length >= 12) {
      event.preventDefault();
      return true;
    }
    if (this.props.field_api_name === 'Postal_Code__c' || this.props.field_api_name === 'Previous_Postal_Code__c') {
      if (value.length >= 9 || !/^[a-zA-Z0-9\s]*$/.test(value)) {
        event.preventDefault();
        return true;
      }
    }
    return false;
  }


  CheckHandleChangeFunctionality = (Currentdatas,name,value,allDetailDatas,currecyCurrentLength) => {
    
    if (this.props.field_type === 'Currency') {
      currecyCurrentLength = Currentdatas.length;
    }

    this.checkQuestionFieldValidation(name,value);
   
    const { field_api_name } = this.props;
    const { Current_Residential_Status__c } = allDetailDatas;

    if (field_api_name === 'Fractional_Residential_Expense__c' &&
        (Current_Residential_Status__c === 'Homeowner - mortgaged' || Current_Residential_Status__c === 'Tenant/Boarding')) {
          if(value.charAt(0)==='0'){
            let stagesValues={}
            stagesValues['Fractional_Residential_Expense__c'] = 'Amount cannot be £0 if your Residential status is Homeowner - mortgaged or Tenant/Boarding';
            stagesValues['stage'] = this.props.stage;
            this.props.appvalidations(stagesValues);
            this.setState((prevState) => {
              return {
                errors: {
                  ...prevState.errors,
                  ['Fractional_Residential_Expense__c']: 'Amount cannot be £0 if your Residential status is Homeowner - mortgaged or Tenant/Boarding'
                }
              }
            })
            return false;
          }
    }

    setTimeout(() => {
      if (name === 'flxNumber_of_Other_Financial_Dependents__c') {
        this.handleChangeForNumberOfDependents(name);
      }
    }, 200);
    return currecyCurrentLength;
  }

  // To validate the loan amount
  loanAmountValidation = (event,value)=>{
    if (this.props.field_type === 'Currency' && value.length !== 0) {
        if (event.target.name === 'genesis__Loan_Amount__c') {
          value = this.handleCheckLoanAmountValidation(value);
        }else{
          value = value.replace(/\D/g, "").split(',').join('');
        }
    }
    return value;
  }

  handleCheckLoanAmountValidation = (value)=> {
    if(value.toString().indexOf(".") >= 0){
      let decimal_position = value.toString().indexOf(".");
      let leftSide = value.substring(0, decimal_position);
      let rightSide = value.substring(decimal_position);
      let replaceLeftSide=leftSide.replace(/\D/g, "").split(',').join('');
      rightSide = rightSide.substring(0, 3);
      if(rightSide.length===2){
        rightSide=rightSide+'0';
      }

    if(rightSide.length===1){
        rightSide='.00';
    }
    value=replaceLeftSide+rightSide;
    }else{
      value = value.replace(/\D/g, "").split(',').join('')+'.00';
    }
    return value;
  }

  //To check application question field validation
  checkQuestionFieldValidation = (name,value) => {

    if ((this.props.field_api_name === 'genesis__bank_account_number__c' || this.props.field_api_name === 'flxNumber_of_Other_Financial_Dependents__c') && value && Number.isNaN(value)) {
      return false;
    }

    setTimeout(() => {
      if (name === 'genesis__Loan_Amount__c' || name === 'Total_Monthly_Income__c') {
        this.handleChangeOfLoanAmount(name);
      }

    }, 200);

    setTimeout(() => {
      switch (name) {
        case 'Last_Name':
          this.handleChangeForLastNameForSectionUpdate();
          break;
        case 'First_Name':
          this.handleChangeForFirstNameForSectionUpdate();
          break;
        case 'flxNumber_of_Other_Financial_Dependents__c':
          this.handleChangeForNumberOfDependentsForSectionUpdate(name);
          break;
        case 'occupation':
          this.handleChangeForOccupationForSectionUpdate(name);
          break;
        default:
          // Handle other cases if needed
      }
    }, 800);
  }

  setPopupView = (src) => {
    if(this.props.field_api_name=='Fractional_Residential_Expense__c' || 
      this.props.field_api_name== 'Fractional_Living_Expense__c' || 
      this.props.field_api_name === 'monthly_expense_financial_commitments' || 
      this.props.field_api_name === 'genesis__Loan_Amount__c' || 
      this.props.field_api_name === 'Total_Monthly_Expenses__c'){
        this.setState(
          {showInformation: src.flxError_Message__c
        })
      }
      else if (this.props.field_api_name == 'Total_Monthly_Income__c' && src.flxMax_Value__c == process.env.REACT_APP_MINIMUM_MONTHLY_INCOME){
        this.setState(
          {
            showInformation:src.flxError_Message__c.replaceAll("\n","<br>"),
            maxValue: src.flxMax_Value__c
          })
      }
  }

  setMaximumThresholdLimitForLoanAmount = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const quoteLoanAmount = urlParams.get('loanAmt');   
    const fieldName = 'genesis__Loan_Amount__c'
    if(quoteLoanAmount !== '' && quoteLoanAmount !== undefined){
      if(this.props.field_api_name === fieldName){
        if (this.props.field_api_validations !== '') {
          this.props.field_api_validations.map((src) => {
            if (src.flxType__c === 'Maximum Range') {
              this.setState({
                maxLoanAmountRange: src.flxMax_Value__c,
                minLoanAmountRange: src.flxMin_Value__c
              })
            }
          })
        }
      }
    }
  }

  setMaximumThresholdLimitForQuoteLoanAmount = () => {
    const fieldName = 'genesis__Loan_Amount__c'
    if(sessionStorage.getItem('quote-loan-amount')){
      if(this.props.field_api_name === fieldName){
        if (this.props.field_api_validations !== '') {
          this.props.field_api_validations.map((src) => {
            if (src.flxType__c === 'Maximum Range') {
              sessionStorage.setItem('maxLoanAmountRange', src.flxMax_Value__c)
              sessionStorage.setItem('minLoanAmountRange', src.flxMin_Value__c)
            }
          })
        }
      }
    }
  }
// Validation of required fields
  handleRequiredFieldValidation = (src,breakCondition,errorValues,stages) => {
    if (src.flxType__c === 'Required Field' && breakCondition === false) {
      if (this.state.input[this.props.field_api_name] === '') {
        errorValues[this.props.field_api_name] = 'This is Required';
        stages[this.props.field_api_name] = 'This is Required';
        stages['stage'] = this.props.stage;
        this.props.appvalidations(stages);
        this.setState({
          errors: errorValues
        });

        breakCondition = true;

      }
    }
    if (src.flxType__c === 'Do not allow negative value') {
      if (this.state.value < 0 && breakCondition === false) {
        errorValues[this.props.field_api_name] = 'Please Enter positive Number';
        stages[this.props.field_api_name] = 'Please Enter positive Number';
        stages['stage'] = this.props.stage;
        this.props.appvalidations(stages);
        this.setState({
          errors: errorValues
        });

        breakCondition = true;
      }
    }
    return breakCondition;
  }

  
  //To validate expenses check
  handleExpensesvalidation = (breakCondition,errorValues,stages,src) => {
    if (this.props.field_api_name === 'Total_Monthly_Expenses__c'  && this.state.input[this.props.field_api_name]<=0 && breakCondition === false) {
      errorValues[this.props.field_api_name] = 'Must be more than £0';
      stages[this.props.field_api_name] = 'Must be more than £0';
      stages['stage'] = this.props.stage;
      this.props.appvalidations(stages);
      this.setState({
        errors: errorValues
      });
      breakCondition = true;
    }

    if (this.props.field_api_name === 'Fractional_Living_Expense__c' && this.state.input[this.props.field_api_name]<=0 && breakCondition === false) {
          errorValues[this.props.field_api_name] = 'Must be more than £0';
          stages[this.props.field_api_name] = 'Must be more than £0';
          stages['stage'] = this.props.stage;
          this.props.appvalidations(stages);
          this.setState({
            errors: errorValues
          });
          breakCondition = true;
    }

    if (src.flxType__c == "Popup View") { 
      this.setPopupView(src);
    }
    return breakCondition;
  }

  handleChangeForFractionalExpensesValidation = (breakCondition,errorValues,stages) => {
    if((this.props.field_api_name === 'Fractional_Residential_Expense__c') && (this.state.input[this.props.field_api_name] <= 0) && (breakCondition === false)) {
          errorValues[this.props.field_api_name] = 'Amount cannot be £0 if your Residential status is Homeowner - mortgaged or Tenant/Boarding';
          stages[this.props.field_api_name] = 'Amount cannot be £0 if your Residential status is Homeowner - mortgaged or Tenant/Boarding';
          stages['stage'] = this.props.stage;
          this.props.appvalidations(stages);
          this.setState({
            errors: errorValues
          });
          breakCondition = true;
      }
    return breakCondition;
  }

  validateEmail = (email) => {
    const allowedSpecialCharecters = "[!#$%&'*+/=?^._`{|}~-]";
    const notUsedConsecutiveSpecialChars = "[!#$%&'*+/=?^`{|}~]";
    const consecutiveSpecialCharsRegex =
      `(?!.*${allowedSpecialCharecters}${notUsedConsecutiveSpecialChars})` +
      `(?!.*${notUsedConsecutiveSpecialChars}${allowedSpecialCharecters})` +
      `(?!.*[.]{2})`;
    const localPartRegex = "[a-zA-Z0-9](?:[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]*[a-zA-Z0-9-_])?";
    const domainPartRegex = "@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}$";
    const emailRegex = new RegExp("^" + consecutiveSpecialCharsRegex + localPartRegex + domainPartRegex + "$");
    return emailRegex.test(email);
  };

  emailValidationCheck(fieldType, src, breakCondition, errorValues, stages, stageValues) {
    this.props.email('');
    this.props.confirmemails('');
    errorValues[this.props.field_api_name] = '';
    stages[this.props.field_api_name] = '';
    stages['stage'] = this.props.stage;
    if (this.state.input[this.props.field_api_name].length < src.flxMin_Value__c || this.state.input[this.props.field_api_name].length > src.flxMax_Value__c && breakCondition === false) {
      errorValues[this.props.field_api_name] = src.flxError_Message__c;
      stages[this.props.field_api_name] = src.flxError_Message__c;
      stages['stage'] = this.props.stage;
      stageValues[fieldType] = false
      this.props.appvalidations(stages);
      this.setState({
        errors: errorValues
      });
      breakCondition = true;
    }
    if (
      /^(([^<>()\\.,;:\s@"]+(\.[^<>()\\.,;:\s@"]+)*)|(".+"))@[a-z0-9-]+(\.[a-z]{2,})+$/i.test(
        this.state.input[this.props.field_api_name]
      ) && this.validateEmail(this.state.input[this.props.field_api_name])) {

      errorValues[this.props.field_api_name] = '';
      stages[this.props.field_api_name] = '';
      stageValues[fieldType] = true
      this.props.appvalidations(stages);
      this.setState({
        errors: errorValues
      });
    } else {
      errorValues[this.props.field_api_name] = 'Please enter a valid email';
      stages[this.props.field_api_name] = 'Please enter a valid email';
      stages['stage'] = this.props.stage;
      stageValues[fieldType] = false
      this.props.appvalidations(stages);
      this.setState({
        errors: errorValues
      });
      breakCondition = true;
    }

    return breakCondition;
  }

  // Validation of email props
  handleEmailpropsValidation = (src,breakCondition,errorValues,stages,stageValues) => {
    if (this.state.inputType === 'email') {
      let emailFieldType = '';
      if (this.props.field_api_name == 'Email_Address') {
        emailFieldType = 'Email_Address';
      }
      if(this.props.field_api_name == 'Confirm_Email_Address') {  
        emailFieldType = 'Confirm_Email_Address';
      }
      breakCondition = this.emailValidationCheck(emailFieldType, src, breakCondition, errorValues, stages, stageValues)         
    }
    return breakCondition;
  }

  handleMobilePropsValidation = (src,errorValues,stages,breakCondition) => {
    if (this.props.field_api_name === 'flxpersonmobile__c') {
      this.props.getPhoneNumber('');
      if (this.state.value.length < src.flxMin_Value__c || this.state.value.length > src.flxMax_Value__c) {

        errorValues[this.props.field_api_name] = src.flxError_Message__c;
        stages[this.props.field_api_name] = src.flxError_Message__c;
        stages['stage'] = this.props.stage;
        this.props.appvalidations(stages);
        this.setState({
          errors: errorValues
        });
        breakCondition = true;
      }
      let mystring = this.state.value.substring(0, 2);
      if (mystring !== '07' && breakCondition === false) {

        errorValues[this.props.field_api_name] = 'This is not a valid UK Phone Number';
        stages[this.props.field_api_name] = 'This is not a valid UK Phone Number';
        stages['stage'] = this.props.stage;
        this.props.appvalidations(stages);
        this.setState({
          errors: errorValues
        });
        breakCondition = true;
      }
    } else {
      let userInputValue = this.state.input[this.props.field_api_name].split(",").join('');
      breakCondition = this.handleMobileLengthandRange(src,userInputValue,errorValues,stages,breakCondition);
    }

    return breakCondition;
  }

  handleMobileLengthandRange = (src,userInputValue,errorValues,stages,breakCondition) => {
    if (src.flxType__c === "Specify Length") {
      if (userInputValue.length < src.flxMin_Value__c || userInputValue.length > src.flxMax_Value__c) {

        errorValues[this.props.field_api_name] = src.flxError_Message__c;
        stages[this.props.field_api_name] = src.flxError_Message__c;
        stages["stage"] = this.props.stage;
        this.props.appvalidations(stages);
        this.setState({
          errors: errorValues
        });
        breakCondition = true;
      }
    }
    if (src.flxType__c === 'Specify Range') {
      if (userInputValue < src.flxMin_Value__c || userInputValue > src.flxMax_Value__c) {
        errorValues[this.props.field_api_name] = src.flxError_Message__c;
        stages[this.props.field_api_name] = src.flxError_Message__c;
        stages['stage'] = this.props.stage;
        this.props.appvalidations(stages);
        this.setState({
          errors: errorValues
        });
        breakCondition = true;
      }
    }
    if (this.state.input[this.props.field_api_name] === 'sortcode_bankaccount') {
      if (userInputValue.length >= 8) {

        errorValues[this.props.field_api_name] = '';
        stages[this.props.field_api_name] = '';
        stages['stage'] = this.props.stage;
        this.props.appvalidations(stages);
        this.setState({
          errors: errorValues
        });
        breakCondition = true;
      }
    }
    return breakCondition;
  }

  handleTextandCurrencyFieldValidation = (breakCondition,src,errorValues,stages) => {
    if (this.state.inputType === 'text' && breakCondition === false && this.props.field_type !== 'Currency') {

      if (this.state.input[this.props.field_api_name].length < src.flxMin_Value__c) {

        errorValues[this.props.field_api_name] = 'This is Required';
        stages[this.props.field_api_name] = 'This is Required';
        stages['stage'] = this.props.stage;
        this.props.appvalidations(stages);
        this.setState({
          errors: errorValues
        });
        breakCondition = true;
      } else if (this.state.input[this.props.field_api_name].length > src.flxMax_Value__c) {
        errorValues[this.props.field_api_name] = src.flxError_Message__c;
        stages[this.props.field_api_name] = src.flxError_Message__c;
        stages['stage'] = this.props.stage;
        this.props.appvalidations(stages);
        this.setState({
          errors: errorValues
        });
        breakCondition = true;
      }
      this.handleFirstNameValidation(breakCondition);
      if (this.props.field_api_name === 'flxFirst_Name__c' || this.props.field_api_name === 'Middle_Name' 
      || this.props.field_api_name === 'flxLast_Name__c' || this.props.field_api_name === 'First_Name' || this.props.field_api_name === 'Last_Name') {
        let inputVal = this.state.input[this.props.field_api_name];

        if (src.flxType__c === 'Specify Length') {
          breakCondition = this.handleNameSpecificLength(inputVal,src,errorValues,stages,breakCondition);
        } else {
          errorValues[this.props.field_api_name] = src.flxError_Message__c;
          stages[this.props.field_api_name] = src.flxError_Message__c;
          stages['stage'] = this.props.stage;
          this.props.appvalidations(stages);
          this.setState({
            errors: errorValues
          });
          breakCondition = true;
        }
      }
    }
    return breakCondition;
  }

  handleFirstNameValidation = (breakCondition) => {
    if (this.props.field_api_name === 'First_Name') {
      let inputVal = this.state.input[this.props.field_api_name]?.trim();
      const basicTitleRegex = /^(mr|ms|mrs|miss|dr|prof|rev|hon|sir|dame|lord|lady|capt|major|col|gen|lt|sgt|fr|rabbi|imam)\b/i;
      const newTitleRegex = /^(bishop|cardinal|baron|baroness|viscount|viscountess|marquess|marchioness|earl|countess|duchess|prince|king)\b/i;
      const titleRegex = new RegExp(`${basicTitleRegex.source}|${newTitleRegex.source}`, 'i');
      const titles = ['mr', 'ms', 'mrs', 'miss', 'dr', 'prof', 'rev', 'hon', 'sir', 'dame', 'lord', 'lady', 'capt', 'major', 'col', 'gen', 'lt', 'sgt', 'fr', 'rabbi', 'imam'];
  
      if (titleRegex.test(inputVal) && !(titles.includes(inputVal.split(/['-]/)[0]?.toLowerCase()) &&/^([a-zA-Z]+)(['-])[a-zA-Z]+(?: [a-zA-Z]+)*$/.test(inputVal))
      ) {
        let errorValues = { ...this.state.errors };
        errorValues[this.props.field_api_name] = 'Titles (e.g., Mr, Ms, Dr, etc) are not allowed in the first name.';
       
        let stages = { ...this.state.stages };
        stages[this.props.field_api_name] = 'Titles (e.g., Mr, Ms, Dr, etc) are not allowed in the first name.';
        stages['stage'] = this.props.stage;
       
        this.props.appvalidations(stages);
        this.setState((prevState) => {
          return {
            errors: {
              ...prevState.errors,
              [this.props.field_api_name]: 'Titles (e.g., Mr, Ms, Dr, etc) are not allowed in the first name.'
            }
          }
        })
      }  
      breakCondition = true;
    }
    return breakCondition;
  };

  handleNameSpecificLength = (inputVal,src,errorValues,stages,breakCondition) => {
    if (inputVal.length < src.flxMin_Value__c || inputVal.length > src.flxMax_Value__c) {
      errorValues[this.props.field_api_name] = src.flxError_Message__c;
      stages[this.props.field_api_name] = src.flxError_Message__c;
      stages['stage'] = this.props.stage;
      this.props.appvalidations(stages);
      this.setState({
        errors: errorValues
      });
      breakCondition = true;
    } else if (this.state.input[this.props.field_api_name].length < src.flxMin_Value__c) {
      errorValues[this.props.field_api_name] = 'This is Required';
      stages[this.props.field_api_name] = 'This is Required';
      stages['stage'] = this.props.stage;
      this.props.appvalidations(stages);
      this.setState({
        errors: errorValues
      });
      breakCondition = true;
    }
    return breakCondition;
  }

  checkAndAssignErrorMessage(errorMessage, invalidValues, inputValue, errorValues, src, stages, breakCondition) {
    if (src.flxError_Message__c === errorMessage && invalidValues.includes(inputValue)) {
      this.assignErrorMessage(errorValues, src, stages);
      breakCondition = true;
    }
    return breakCondition;
  }

  checkAddressFieldValidation(src,errorValues,stages,breakCondition){  
    let getInputValue = this.state.input[this.props.field_api_name].split(',').join('');
      
    if(this.props.field_api_name === 'Address_Line1__c' || this.props.field_api_name === 'Town__c'
          || this.props.field_api_name === 'Previous_Address_Line1__c' || this.props.field_api_name === 'Previous_Town__c'){
              if (src.flxType__c ==='Specify Length') {
                if (getInputValue.length < src.flxMin_Value__c || getInputValue.length > src.flxMax_Value__c) {

                  errorValues[this.props.field_api_name] = src.flxError_Message__c;
                  stages[this.props.field_api_name] = src.flxError_Message__c;
                  stages['stage'] = this.props.stage;
                  this.props.appvalidations(stages);
                  this.setState({
                    errors: errorValues
                  });
                  breakCondition = true;
                }
              }
    } else if (this.props.field_api_name === 'Current_Flat_No__c' || this.props.field_api_name === 'Current_House_Name__c' || this.props.field_api_name === 'HouseNumber__c' || this.props.field_api_name==='Previous_Flat_No__c' || this.props.field_api_name==='Previous_House_Name__c' || this.props.field_api_name==='Previous_HouseNumber__c'){            
              if (src.flxType__c ==='Specify Length' && getInputValue.length > src.flxMax_Value__c) {
                  errorValues[this.props.field_api_name] = src.flxError_Message__c;
                  stages[this.props.field_api_name] = src.flxError_Message__c;
                  stages['stage'] = this.props.stage;
                  this.props.appvalidations(stages);
                  this.setState({
                    errors: errorValues
                  });
                  return;              
              }
          }
          return breakCondition;
  }
  
  handleNumberFieldValidation = (src,getUserInputValue,errorValues,stages,breakCondition) => {
    if (src.flxType__c ==="Specify Length") {
      if (getUserInputValue.length < src.flxMin_Value__c || getUserInputValue.length > src.flxMax_Value__c) {

        errorValues[this.props.field_api_name] = src.flxError_Message__c;
        stages[this.props.field_api_name] = src.flxError_Message__c;
        stages["stage"]= this.props.stage;
        this.props.appvalidations(stages);
        this.setState({
          errors: errorValues
        });
        breakCondition = true;
      }
    }

    if (this.props.field_api_name === 'genesis__bank_account_number__c') {
      if (getUserInputValue.length >= 9) {
        if (this.state.errors['genesis__bank_account_number__c'] == 'Must be 8 digit numeric value') {
          errorValues[this.props.field_api_name] = src.flxError_Message__c;
          stages[this.props.field_api_name] = src.flxError_Message__c;
          stages['stage'] = this.props.stage;
          this.props.appvalidations(stages);
          this.setState({
            errors: errorValues
          });
          breakCondition = true;
        }
      }
    }
    return breakCondition;
  }

  handleTextFieldValidation = (src,inputValue,errorValues,stages,breakCondition) => {
    const { flxType__c, flxMin_Value__c, flxMax_Value__c } = src;
    if (flxType__c === 'Specify Length' && (inputValue.length < flxMin_Value__c || inputValue.length > flxMax_Value__c)) {
        errorValues[this.props.field_api_name] = src.flxError_Message__c;
        stages[this.props.field_api_name] = src.flxError_Message__c;
        stages['stage'] = this.props.stage;
        this.props.appvalidations(stages);
        this.setState({
          errors: errorValues
        });
        breakCondition = true;
    }
    if (this.props.field_api_name === "sortcode_bankaccount") {
      if (inputValue.length >= 8) {
        if (this.state.errors['sortcode_bankaccount'] == 'Must be 6 digit numeric value') {
          errorValues[this.props.field_api_name] = src.flxError_Message__c;
          stages[this.props.field_api_name] = src.flxError_Message__c;
          stages['stage'] = this.props.stage;
          this.props.appvalidations(stages);
          this.setState({
            errors: errorValues
          });
          breakCondition = true;
        }
      }
      if (src.flxType__c === 'Specify Length') {
        if (inputValue.length < src.flxMin_Value__c || inputValue.length > src.flxMax_Value__c) {

          errorValues[this.props.field_api_name] = src.flxError_Message__c;
          stages[this.props.field_api_name] = src.flxError_Message__c;
          stages['stage'] = this.props.stage;
          this.props.appvalidations(stages);
          this.setState({
            errors: errorValues
          });
          breakCondition = true;
        }
      }
    }
    return breakCondition;
  }

  handlingValidations = () => {
    let breakCondition = false;
    let errorValues = this.state.errors;
    errorValues[this.props.field_api_name] = '';
    this.setState((prevState) => {
      return {
        errors: {
          ...prevState.errors,
          [this.props.field_api_name]: ''
        }
      }
    })
    let stages = {};
    let stageValues = {}
    stages[this.props.field_api_name] = '';
    stages['stage'] = this.props.stage;
    this.props.appvalidations(stages);
    if (this.props.field_api_validations !== '') {
      let checkContainsValidation = this.props.field_api_validations.filter(src => src.flxType__c === 'Contains');
      if (checkContainsValidation.length > 0) {
        breakCondition = this.checkHandleContainsValidation(breakCondition, errorValues, stages);
      } else {
        this.props.field_api_validations.map((src) => {

          // Validation of required fields
          breakCondition = this.handleRequiredFieldValidation(src, breakCondition, errorValues, stages);
          breakCondition = this.handleChangeForMobileNumber(breakCondition, errorValues);
          breakCondition = this.handleChangeForFractionalExpensesValidation(breakCondition, errorValues, stages);
          //To validate expenses check
          breakCondition = this.handleExpensesvalidation(breakCondition, errorValues, stages, src);
          if (this.state.inputType === 'email' && this.state.input[this.props.field_api_name] === '') {
            breakCondition = false;
          }
          if (src.minmaxrequired === true && breakCondition === false) {

            // Validation of email props
            breakCondition = this.handleEmailpropsValidation(src, breakCondition, errorValues, stages, stageValues);

            let inputValue = this.state.input[this.props.field_api_name];
            breakCondition = this.handleChangeForLoanAmountAndIncome(src, breakCondition, errorValues, inputValue)

            if ((this.state.inputType === 'number' || this.props.field_type === 'Currency' || this.props.field_api_name === 'sortcode_bankaccount') && breakCondition === false) {
              breakCondition = this.handleMobilePropsValidation(src, errorValues, stages, breakCondition);
            }

            breakCondition = this.checkAndAssignErrorMessage("Must be numeric value and six zeros or six nines not allowed", ["000000", "999999"], inputValue, errorValues, src, stages, breakCondition);
            breakCondition = this.checkAndAssignErrorMessage("Must be numeric value and eight zeros or eight nines not allowed", ["00000000", "99999999"], inputValue, errorValues, src, stages, breakCondition);
            breakCondition = this.checkAddressFieldValidation(src, errorValues, stages, breakCondition);
            breakCondition = this.handleTextandCurrencyFieldValidation(breakCondition, src, errorValues, stages);
          } else if (!src.minmaxrequired && !breakCondition) {
            breakCondition = this.checkNumberandTextMinimumandmaximumValidation(breakCondition, src, errorValues, stages);
          }
        })
      }
    }

    this.props.firstSectionValidationUpdate(stageValues);

    const previousAddressFields = ['Previous_Address_Line1__c', 'Previous_Town__c', 'Previous_Postal_Code__c'];
    if (previousAddressFields.includes(this.props.field_api_name)) {
      const inputValue = this.state.input[this.props.field_api_name];
      
      let thirdSectionStageValues = {};
      if (inputValue === '' || !inputValue) {
        thirdSectionStageValues[this.props.field_api_name] = false;
      } else {
        thirdSectionStageValues[this.props.field_api_name] = true;
      }
    }

  }

  checkHandleContainsValidation = (breakCondition, errorValues, stages) => {
    try {
      this.props.field_api_validations.map((src) => {
        breakCondition = this.handleRequiredFieldValidation(src, breakCondition, errorValues, stages);
        if (src.minmaxrequired === true && breakCondition === false) {
          if (this.props.field_api_name === 'genesis__Loan_Amount__c') {
            let inputValue = this.state.input[this.props.field_api_name];
            let updatedErrorMessage = this.handleRetailerErrorMessage(src,inputValue,errorValues,stages);
            if(updatedErrorMessage === false){
              return updatedErrorMessage;
            }
          }
        } else if (!src.minmaxrequired && !breakCondition) {
          breakCondition = this.checkNumberandTextMinimumandmaximumValidation(breakCondition, src, errorValues, stages);
        }
      });
      return breakCondition;
    } catch (error) {
      frontEndLogs('Catch Error', true, 400, 'checkHandleContainsValidation', error.message);
    }
  }

  handleRetailerErrorMessage = (src,inputValue,errorValues,stages)=>{
    if (src.flxMin_Value__c > inputValue || src.flxMax_Value__c < inputValue) {
      let errorMessage = src.flxError_Message__c;
      if (errorMessage.includes('LOAN_AMOUNT')) {
        let loanAmount = this.updateCuruncyamount(inputValue)
        if (loanAmount) {
          errorMessage = errorMessage.replace('LOAN_AMOUNT', loanAmount)
          frontEndLogs('Loan Amount Validation', false, 200, 'handleRetailerErrorMessage', { inputValue, 'errors': this.state.errors });
        } else {
          return false;
        }
      }
      errorValues['genesis__Loan_Amount__c'] = errorMessage;
      stages['genesis__Loan_Amount__c'] = errorMessage;
      stages['stage'] = this.props.stage;
      this.props.appvalidations(stages);
      this.setState({
        errors: errorValues
      });
    }
  }

  checkNumberandTextMinimumandmaximumValidation = (breakCondition,src,errorValues,stages) => {
    let inputValue;
    if (breakCondition === false) {
      if (this.state.inputType === 'number' || this.state.inputType === 'text') {
        inputValue = this.state.input[this.props.field_api_name].split(',').join('');
        breakCondition = this.state.inputType === 'number'
          ? this.handleNumberFieldValidation(src, inputValue, errorValues, stages, breakCondition)
          : this.handleTextFieldValidation(src, inputValue, errorValues, stages, breakCondition);
      }
    }
    return breakCondition;
  }

  onKeyPressDataForMobileNumber = (event,invalidCharacters) => {

    if (this.props.field_api_name === 'Mobile_Number' ||this.props.field_api_name === 'flxpersonmobile__c') {
      if (!/\d/.test(event.key)) {
        event.preventDefault();
        return false;
      }
      if (invalidCharacters.includes(event.key)) {
          event.preventDefault();
      }
      if(event.target.value.length >= 11){
        event.preventDefault();
      }

      if (/[a-zA-Z]/.test(event.key)) {
        event.preventDefault();
      }
    }

    if (this.props.field_api_name === 'flxpersonmobile__c') {
      if (!/\d/.test(event.key)) {
        event.preventDefault();
      }
    }

  }

  firstLastNameValidation(event) {
    const inputElement = event.target;
    let fieldValue = inputElement.value;
    if (this.props.field_api_name === 'First_Name' || this.props.field_api_name === 'Last_Name' || this.props.field_api_name === 'flxLast_Name__c') {
      const originalCursor = inputElement.selectionStart;
      let wasModified = false;
      const trimmed = fieldValue.replace(/^[-']+/, '');
      const removedFromEnds = fieldValue.length - trimmed.length;
      if (fieldValue !== trimmed) wasModified = true;
      fieldValue = trimmed;
      const before = fieldValue;
      fieldValue = fieldValue.replace(/(-')|('-)/g, (match) => match[0]);
      const removedInMiddle = before.length - fieldValue.length;
      if (fieldValue !== before) wasModified = true;
      this.props.fieldChange(this.props.field_api_name, fieldValue, this.props.field_type, event, this.state.keyData);
      if (wasModified) {
        setTimeout(() => {
          const newCursorPos = Math.max(0, originalCursor - removedFromEnds - removedInMiddle);
          inputElement.setSelectionRange(newCursorPos, newCursorPos);
        }, 0);
      }
    }

    return fieldValue;
  }

  onKeyPressDataForMonthlyIncome = (event) => {
    if (this.props.field_api_name === 'Total_Monthly_Income__c') {
      const inputElement = event.target;
      const currentValue = inputElement.value.replace(/,/g, '');
      if (currentValue.startsWith('0')) {
        event.preventDefault();
        return;
      }
      if (currentValue >= 20000 || Number.isNaN(currentValue)) {
        event.preventDefault();
      }
    }
  };


  onKeyPressDataForFirstNameAndLastName = (event) => {  
    if (this.props.field_api_name === 'First_Name' || this.props.field_api_name === 'Last_Name' || this.props.field_api_name === 'flxLast_Name__c') {
      this.firstLastNameValidation(event)

      if (!/^(?!.*[0-9!@#$%^&*()_+{}[\]:;<>,.?\\|])(([a-zA-Z-' ]+( [a-zA-Z-']+)?)|([a-zA-Z-']+))$/.test(event.key)) {
        event.preventDefault();
        return false;
      }

      if (!/[a-z-' ]/i.test(event.key) || /\d/.test(event.key)  || /[~`!@#$£%^&*()_+=[\]{};:"\\|,.<>/?]+/.test(event.key) || /"+/.test(event.key)) {
        event.preventDefault();
        return false;
      }
  
      if (!/^[a-zA-Z-' ]$/.test(event.key)) {
        event.preventDefault();
        return false;
      }
    }
  };
  
  
  
  

  handleChangeForMobileNumber = (breakCondition, errorValues) => {
    let stageValues= {}, stages = {};
    if(this.props.field_api_name === 'Mobile_Number' || this.props.field_api_name === 'flxpersonmobile__c') {
      let getInputValue = this.state.input[this.props.field_api_name];
      let ukPhoneNumberPrefix = getInputValue.substring(0, 2);
      if(getInputValue.length === 11){
        errorValues[this.props.field_api_name] = '';
        stages[this.props.field_api_name] = '';
        stages['stage'] = this.props.stage;
        stageValues['Mobile_Number'] = true
        this.props.appvalidations(stages);
        this.setState({
          errors: errorValues
        });
        breakCondition = true;

        if(ukPhoneNumberPrefix !== '07'){
          errorValues[this.props.field_api_name] = 'Enter a valid mobile number';
          stages[this.props.field_api_name] = 'Enter a valid mobile number';
          stages['stage'] = this.props.stage;
          stageValues['Mobile_Number'] = false
          this.props.appvalidations(stages);
          this.setState({
            errors: errorValues
          });
          breakCondition = true;
        }
      }
      else if(getInputValue.length == 0){
        errorValues[this.props.field_api_name] = 'This is Required';
        stages[this.props.field_api_name] = 'This is Required';
        stages['stage'] = this.props.stage;
        stageValues['Mobile_Number'] = false
        this.props.appvalidations(stages);
        this.setState({
          errors: errorValues
        });
        breakCondition = true;
      }
      else if(getInputValue.length >=1 ||  getInputValue.length <11){
        errorValues[this.props.field_api_name] = 'Invalid UK mobile number format';
        stages[this.props.field_api_name] = 'Invalid UK mobile number format';
        stages['stage'] = this.props.stage;
        stageValues['Mobile_Number'] = false
        this.props.appvalidations(stages);
        this.setState({
          errors: errorValues
        });
        breakCondition = true;
      }
        
    }

    this.props.firstSectionValidationUpdate(stageValues);

    return breakCondition;
  }

  handleChangeForLoanAmountAndIncome = (src, breakCondition, errorValues, inputValue) => {
    let stages = {};

    if (this.props.field_api_name === 'genesis__Loan_Amount__c' || this.props.field_api_name === 'Total_Monthly_Income__c') {
      if (src.flxType__c === 'Minimum Range') {
        if (src.flxMin_Value__c > inputValue) {
          errorValues[this.props.field_api_name] = src.flxError_Message__c;
          stages[this.props.field_api_name] = src.flxError_Message__c;
          stages['stage'] = this.props.stage;
          this.props.appvalidations(stages);
          this.setState({
            errors: errorValues
          });
          breakCondition = true;
        }
        
        frontEndLogs('Loan Amount Validation', false, 200, 'handleChangeForLoanAmountAndIncome', { inputValue, 'errors': this.state.errors });
      }
      if (src.flxType__c === 'Maximum Range') {
        if (src.flxMax_Value__c < inputValue) {
          errorValues[this.props.field_api_name] = src.flxError_Message__c;
          stages[this.props.field_api_name] = src.flxError_Message__c;
          stages['stage'] = this.props.stage;
          this.props.appvalidations(stages);
          this.setState({
            errors: errorValues
          });
          breakCondition = true;
        }
      }
      frontEndLogs('Loan Amount Validation', false, 200, 'handleChangeForLoanAmountAndIncome', { inputValue, 'errors': this.state.errors });
    }
    
    return breakCondition;
  }

  handleChangeOfLoanAmount = (name) => {
    let stageValues ={}
    if(name === 'genesis__Loan_Amount__c') {
      const allDetails = Object.assign({}, ...this.props.applicationValidation);  

      if(allDetails['genesis__Loan_Amount__c'] == '') {
        stageValues['genesis__Loan_Amount__c'] = true
        this.props.secondSectionValidationUpdate(stageValues);
      }
      else {
        stageValues['genesis__Loan_Amount__c'] = false
        this.props.secondSectionValidationUpdate(stageValues);
      }

    }

    if(name === 'Total_Monthly_Income__c') {
      const allDetails = Object.assign({}, ...this.props.applicationValidation);  

      if(allDetails['Total_Monthly_Income__c'] == '') {
        stageValues[name] = true
        this.props.fourSectionValidationUpdate(stageValues);
      } else {
        stageValues[name] = false
        this.props.fourSectionValidationUpdate(stageValues);
      }

    }
  }

  handleChangeForNumberOfDependentsForSectionUpdate = (name) => {
    const allUserDetails = Object.assign({}, ...this.props.applicationValidation);  
    let stageValues = {}

    if(name === 'flxNumber_of_Other_Financial_Dependents__c') {
      if(allUserDetails['flxNumber_of_Other_Financial_Dependents__c'] == '') {
        stageValues['flxNumber_of_Other_Financial_Dependents__c'] = true
      }
      else {
        stageValues['flxNumber_of_Other_Financial_Dependents__c'] = false
      }
  
      this.props.fourSectionValidationUpdate(stageValues);
    }
    
  }

  handleChangeForOccupationForSectionUpdate = (name) => {
    const allUserDetails = Object.assign({}, ...this.props.applicationValidation);  
    let stageValues = {}

    if(name === 'occupation') {
      if(allUserDetails['occupation'] == '') {
        stageValues['occupation'] = true
      }
      else {
        stageValues['occupation'] = false
      }
  
      this.props.fourSectionValidationUpdate(stageValues);
    }
    
  }

  handleChangeForLastNameForSectionUpdate = () => {
    const allUserDetails = Object.assign({}, ...this.props.applicationValidation);  
    let stageValues = {}

    if(allUserDetails['Last_Name'] == '') {
      stageValues['Last_Name'] = true
    }
    else {
      stageValues['Last_Name'] = false
    }

    this.props.firstSectionValidationUpdate(stageValues);
  }

  handleChangeForFirstNameForSectionUpdate = () => {
    const allUserDetails = Object.assign({}, ...this.props.applicationValidation);  
    let stageValues = {}

    if(allUserDetails['First_Name'] == '') {
      stageValues['First_Name'] = true
    }
    else {
      stageValues['First_Name'] = false
    }

    this.props.firstSectionValidationUpdate(stageValues);
  }


  onKeyPressDataForAccountNumber = (event, invalidCharacters) => {
    if (this.props.field_api_name === 'genesis__bank_account_number__c') {
      if (!/\d/.test(event.key)) {
        event.preventDefault();
        return false;
      }

      if (event.target.value.length > 7) {
        event.preventDefault();
        return false;
      }
      if (invalidCharacters.includes(event.key)) {
        event.preventDefault();
        return false;
      }
    }
  }

  onKeyPressDataForFinanicalDependents = (event, invalidCharacters) => {
    if (this.props.field_api_name === 'flxNumber_of_Other_Financial_Dependents__c') {
      if (!/\d/.test(event.key)) {
        event.preventDefault();
        return false;
      }
      if (event.target.value.length+1 > 1) {
        event.preventDefault();
        return false;
      }

      if (invalidCharacters.includes(event.key)) {
        event.preventDefault();
      }
    }
  }

  onKeyPressDataForEmailAndSortCode = (event) => {

    if (this.props.field_api_name === 'occupation') {

      if (!/[a-z ]/i.test(event.key)) {
        event.preventDefault();
        return false;
      }

    }

    if (this.props.field_api_name === 'flxPersonEmail__c' || this.props.field_api_name === 'Email_Address') {
      if (event.target.value.length > 49) {
        event.preventDefault();
      }
    }

    if (this.props.field_api_name === 'Confirm_Email_Address') {
      if (event.target.value.length > 49) {
        event.preventDefault();
      }
    }

    if (this.props.field_api_name === 'sortcode_bankaccount') {

      if (event.key === "-") {
        event.preventDefault();
        return false;
      }
    }


  }
  


  onKeyPressData = (event) => {
    event.persist();


    let invalidChars = [
      "e",
      "E",
      "+",
      ".",
      ",",
      "-"
    ];

    let validatedResponse = this.handleAddressQuestionFieldValidation(this.props.field_api_name,event.key);
    if(!validatedResponse){
      event.preventDefault();
      return false;
    }

    this.onKeyPressDataForFirstNameAndLastName(event);
    
    this.onKeyPressDataForEmailAndSortCode(event)
    
    this.onKeyPressDataForMobileNumber(event, invalidChars)

    this.onKeyPressDataForAccountNumber(event, invalidChars);
   

    this.onKeyPressDataForFinanicalDependents(event, invalidChars)

    this.onKeyPressDataForMonthlyIncome(event)

    if (this.props.field_api_name === 'sortcode_bankaccount' || this.props.field_api_name === 'genesis__bank_account_number__c' || this.props.field_api_name === 'flxNumber_of_Other_Financial_Dependents__c') {
   

      if (event.key === "-") {
        event.preventDefault();

        return false;
      }
  
    }
  


    if(this.props.field_api_name === 'genesis__Loan_Amount__c'){
      if (!/([\d.,]+)/g.test(event.key)) {
        event.preventDefault();
      }
    }

    if (this.props.field_type === 'Currency' && this.props.field_api_name != 'genesis__Loan_Amount__c') {
      if (/^\d+[.,]\d{2}$/.test(event.key)) {
        event.preventDefault();
      }
      if (invalidChars.includes(event.key)) {
        event.preventDefault();
      }
    }
    
  }

  onlyAcceptInputPasteCheckForMobileNumber = (event) => {
    if(this.props.field_api_name === 'flxpersonmobile__c' || this.props.field_api_name === 'Mobile_Number'){
      if(!/\d/.test(event.clipboardData.getData('Text')) || /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/.test(event.clipboardData.getData('Text'))){
        event.preventDefault();
      }
    }
  }

  handleInputsForTotalMonthlyIncome = (event) => {
    if (this.props.field_api_name === 'Total_Monthly_Income__c') {
        const inputElement = event.target;        
        let pastedValue = event.clipboardData.getData('text').replace(/,/g, '');    
        let currentValue = inputElement.value.replace(/,/g, '');

        if (!/^\d+$/.test(pastedValue)) {
          event.preventDefault();
          return;
        }
        if (Number.parseFloat(currentValue) >= 20000 || Number.isNaN(currentValue)) {
          event.preventDefault();
        } else {
          setTimeout(() => {
            inputElement.value = currentValue;
            inputElement.setSelectionRange(currentValue + pastedValue.length, currentValue + pastedValue.length);
          }, 0);
        }
      }  
    }    


  onInputChange = (event) => {
    if (this.props.field_api_name === 'flxNumber_of_Other_Financial_Dependents__c' || this.props.field_api_name == 'Mobile_Number') {
    const sanitizedValue = event.target.value.replace(/[.,-]/g, '');
    event.target.value = sanitizedValue;
    }
    if (this.props.field_api_name === 'occupation') {
      const sanitizedValue = event.target.value.replace(/[^a-zA-Z ]/g, '');
      event.target.value = sanitizedValue;
    }
  };
  
  onlyAcceptInputsPaste = (event) => {
    const alphaRegexPattern = /[a-z ]/i
    if (this.props.field_api_name === 'flxFirst_Name__c' || this.props.field_api_name === 'occupation') {

      if (!alphaRegexPattern.test(event.clipboardData.getData('Text')) || /\d/.test(event.clipboardData.getData('Text')) || /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/.test(event.clipboardData.getData('Text'))) {
        event.preventDefault();
      }
    }
    if (this.props.field_api_name === 'sortcode_bankaccount' || this.props.field_api_name === 'genesis__bank_account_number__c') {
      if (event.clipboardData.getData('Text').length <= 6) {
        return false
      }
      if (!/\d/.test(event.clipboardData.getData('Text')) || /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/.test(event.clipboardData.getData('Text'))) {
        event.preventDefault();
      }
    }

    this.excludeAddressFields(event);
    this.onlyAcceptInputPasteCheckForMobileNumber(event);
    this.handleInputsForTotalMonthlyIncome(event);
  } 

  excludeAddressFields = (event)=>{
    const excludedFields = [
      'Current_Flat_No__c',
      'Current_House_Name__c',
      'HouseNumber__c',
      'Address_Line1__c',
      'Address_Line2__c',
      'Town__c'
    ];
    
    if (!excludedFields.includes(this.props.field_api_name) &&
      this.props.field_type === 'Text' &&
      !/^[\x20-\x7F]*$/.test(event.clipboardData.getData('Text'))) {
        event.preventDefault();
    }
  }

  handleAddressQuestionFieldValidation = (fieldName,value) => {
    if(fieldName === 'Current_Flat_No__c' || fieldName === 'Current_House_Name__c' || fieldName === 'HouseNumber__c' || fieldName === 'Address_Line1__c' || fieldName === 'Address_Line2__c' || fieldName === 'Town__c' || fieldName === 'Previous_Flat_No__c' || fieldName === 'Previous_House_Name__c' || fieldName === 'Previous_HouseNumber__c' || fieldName === 'Previous_Address_Line1__c' || fieldName === 'Previous_Address_Line2__c' || fieldName === 'Previous_Town__c'){
      return handleAddressFiledValidation(fieldName,value);
    }else{
      return true;
    }
  }

  onlyAcceptInputs = (e) => {
    if (this.props.field_api_name === 'flxPersonConfirmEmail__c') {
      e.preventDefault();
    }
    let validatedResponse = this.handleAddressQuestionFieldValidation(this.props.field_api_name,e.clipboardData.getData('Text'))
    if(!validatedResponse){
      e.preventDefault();
    }

    if(this.props.field_api_name === 'Postal_Code__c' || this.props.field_api_name === 'Previous_Postal_Code__c'){
      if (!/^[a-zA-Z0-9\s]*$/.test(e.clipboardData.getData('Text'))){
        e.preventDefault();
      }
    }

    if (this.props.field_api_name === 'First_Name' || this.props.field_api_name === 'flxLast_Name__c' || this.props.field_api_name === 'Last_Name') {
      const pastedText = e.clipboardData.getData('Text').trim();
      const invalidCharacters = /[^a-zA-Z-' ]/g; 
      const hyphenCount = (pastedText.match(/-/g) || []).length;
      const apostropheCount = (pastedText.match(/'/g) || []).length;
  
      if (invalidCharacters.test(pastedText) || hyphenCount > 1 || apostropheCount > 1 || pastedText.startsWith("-") || pastedText.startsWith("'") || pastedText.endsWith("-") || pastedText.endsWith("'")) {
          e.preventDefault();
      }
    }

    this.onlyAcceptInputsPaste(e);
    if(this.props.field_api_name === 'flxNumber_of_Other_Financial_Dependents__c'){
      if (!/\d/.test(e.clipboardData.getData('Text')) || /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/.test(e.clipboardData.getData('Text')) || e.clipboardData.getData('Text') > 9) {
        e.preventDefault();
      }
    }
  }

  onKeyPressDown = (event) => {
    this.firstLastNameValidation(event)
    let validateResponse = this.handleAddressQuestionFieldValidation(event.target.name,event.key);
    if (!validateResponse) {
      return false;
    }
    this.setState({ keyData: event.key });
  }

  occupationValidation = (userAllowValue) => {
    if (this.props.employmentStatus === true && userAllowValue === true && this.props.field_api_name === 'occupation') {
      userAllowValue = true
    }
    return userAllowValue
  }

  occupationCheck = (userAllowValue) => {
    if (this.props.employmentStatus === false && this.props.field_api_name === 'occupation') {
      userAllowValue = false;
    }
    return userAllowValue
  }

  checkIfMobileVerified = (userAllDetailsData, fieldDisableValue) => {

    if(this.props.field_api_name == 'Mobile_Number' && this.props.editable === false && this.props.isMobileVerified  && userAllDetailsData[this.props.field_api_name] != '' && userAllDetailsData[this.props.field_api_name] != null && userAllDetailsData !== undefined) {
      fieldDisableValue = true
    }

    if(this.props.field_api_name == 'Email_Address' && this.props.isMobileVerified) {
      fieldDisableValue = true
    }

    if(this.props.field_api_name == 'Confirm_Email_Address' && this.props.isMobileVerified) {
      fieldDisableValue = true
    }

    return fieldDisableValue;    
  }

  checkIfChangeEmailClicked = (userAllDetailsData, fieldDisableValue) => {
    if(this.props.field_api_name == 'First_Name' && this.props.editable === false && this.props.isChangeEmail  && userAllDetailsData[this.props.field_api_name] != '' && userAllDetailsData[this.props.field_api_name] != null && userAllDetailsData !== undefined) {
      fieldDisableValue = true
    }

    if(this.props.field_api_name == 'Last_Name' && this.props.editable === false && this.props.isChangeEmail  && userAllDetailsData[this.props.field_api_name] != '' && userAllDetailsData[this.props.field_api_name] != null && userAllDetailsData !== undefined) {
      fieldDisableValue = true
    }

    if(this.props.field_api_name == 'Mobile_Number' && this.props.editable === false && this.props.isChangeEmail  && userAllDetailsData[this.props.field_api_name] != '' && userAllDetailsData[this.props.field_api_name] != null && userAllDetailsData !== undefined) {
      fieldDisableValue = true
    }

    return fieldDisableValue;
  }

  checkIfEmailVerified = (userAllDetailsData, fieldDisableValue) => {
    // Email field is now always editable for logged-in users
    if(this.props.field_api_name == 'Email_Address' && this.props.editable === false && this.props.isEmailVerified  && userAllDetailsData[this.props.field_api_name] != '' && userAllDetailsData[this.props.field_api_name] != null && userAllDetailsData !== undefined) {
      fieldDisableValue = false
    }

    return fieldDisableValue;
  }

  prepopulateCondition = (userAllDetailsData, fieldDisableValue) => {

    if(this.props.isMobileVerified) {
      fieldDisableValue = this.checkIfMobileVerified(userAllDetailsData, fieldDisableValue);
    }

    if(this.props.isEmailVerified) {
      fieldDisableValue = this.checkIfEmailVerified(userAllDetailsData, fieldDisableValue);
    }

    if(this.props.isChangeEmail) {
      fieldDisableValue = this.checkIfChangeEmailClicked(userAllDetailsData, fieldDisableValue);
    }

    if(this.props.field_api_name == 'First_Name' && this.props.editable === false 
      && !this.props.firstNameFlag && userAllDetailsData[this.props.field_api_name] != '' && 
      userAllDetailsData[this.props.field_api_name] != null) {
        fieldDisableValue = false
        return fieldDisableValue
    }

    if (this.props.editable === false && this.props.prepopulateStatus === true && 
      userAllDetailsData[this.props.field_api_name] != '' && userAllDetailsData[this.props.field_api_name] != null 
      && userAllDetailsData !== undefined && this.props.prepopulateCondition === true && this.props.field_api_name !== 'Email_Address') {
      fieldDisableValue = true
      return fieldDisableValue
    }

    fieldDisableValue = this.userDetailsPrepopulateCondition(userAllDetailsData, fieldDisableValue);
    return fieldDisableValue
  }

  disableNameFieldOnAmending = (userAllDetailsData, fieldDisableValue) => {
    if (this.props.goBackAmendClicked) {
      if (this.props.field_api_name == 'First_Name' || this.props.field_api_name == 'Last_Name') {
        if (userAllDetailsData?.[this.props.field_api_name]) {
          fieldDisableValue = true;
        }
      }
      
      if (this.props.field_api_name == 'Email_Address' || this.props.field_api_name == 'Confirm_Email_Address') {
        if (userAllDetailsData?.[this.props.field_api_name]) {
          fieldDisableValue = true;
        }
      }
    }
    return fieldDisableValue
  }

  userDetailsPrepopulateCondition = (userAllDetailsData, fieldDisableValue) => {
    if(this.props.field_api_name == 'First_Name' && this.props.editable === false 
       && this.props.firstNameFlag && userAllDetailsData[this.props.field_api_name] != '' && 
      userAllDetailsData[this.props.field_api_name] != null && 
      (this.props.userDetailsPopulateStatus ||this.props.prepopulateStatus)) {
      fieldDisableValue = true
    }

    if(this.props.field_api_name == 'Last_Name' && this.props.editable === false  && this.props.lastNameFlag && 
      userAllDetailsData[this.props.field_api_name] != '' && userAllDetailsData[this.props.field_api_name] != null && 
      (this.props.userDetailsPopulateStatus ||this.props.prepopulateStatus)) {
      fieldDisableValue = true
    }

    if(this.props.field_api_name == 'Email_Address' && this.props.editable === false && this.props.emailFlag && 
      userAllDetailsData[this.props.field_api_name] != '' && userAllDetailsData[this.props.field_api_name] != null 
      && (this.props.userDetailsPopulateStatus ||this.props.prepopulateStatus)) {
      if ((localStorage.getItem('fromWhere') !== 'apply_now' && sessionStorage.getItem('fromWhere') !== 'apply_now') && this.props.isMobileVerified) {
        fieldDisableValue = true;
      } 
      else {
        fieldDisableValue = false;
      }
    }

    if(this.props.field_api_name == 'Mobile_Number' && this.props.editable === false &&  this.props.mobileNumberFlag 
      && userAllDetailsData[this.props.field_api_name] != '' && userAllDetailsData[this.props.field_api_name] != null && 
      (this.props.userDetailsPopulateStatus ||this.props.prepopulateStatus)) {
      fieldDisableValue = true
    }

    return fieldDisableValue;
  }

  residentialFieldDisableCheck = (userAllDetails, fieldDisableValue) => {
    if (this.props.field_api_name === 'Fractional_Residential_Expense__c' &&
        (userAllDetails['Current_Residential_Status__c'] === 'Homeowner - no mortgage' || 
         userAllDetails['Current_Residential_Status__c'] === 'Living with parents/family')) {
        fieldDisableValue = false;
    }
    return fieldDisableValue
  }

  classNameForInputField = (userAllDetailData, fieldDisableValue) => {

    // styling after amount is entered for currency input field
    if(this.props.field_type === 'Currency' && userAllDetailData[this.props.field_api_name] !== undefined && userAllDetailData[this.props.field_api_name] !== '') {
      return ('form-control custom-cat-displays')
    }
    // styling when the prepopulated input fields are disabled
    else if(fieldDisableValue){
      return('form-control disable-field')
    }
    // styling for input fields which are editable
    else {
      return('form-control');
    }

  }

  classNameForDivElement= (props) => {
   
      return('dynamic-input'+" "+props.field_api_name);
    
  }

  onBlurEvent = () => {
    if (this.props.onBlurInputFiled) {
      if (this.inputRef.current) {
        this.inputRef.current.blur();
      }
    }
  }

  handleBlur = (event) => {
    const allDetailData = Object.assign({}, ...this.props.saveApplicationData);
    let fieldName = event.target.name;
    let value;
    if (fieldName === "First_Name" || fieldName === "Last_Name") {
        value = allDetailData[fieldName] || ""; 

        value = String(value).trim(); 

        if (value.startsWith('-') || value.startsWith("'")) {
            value = value.slice(1); 
        }
        if (value.endsWith('-') || value.endsWith("'")) {
            value = value.slice(0, -1); 
            if (value.endsWith('-') || value.endsWith("'")) {
              value = value.slice(0, -1);
            }
        }

        const invalidPattern = /['-]{2,}/;
        value = value.replace(invalidPattern, (match) => match[0]); 

        this.setState({ [fieldName]: value });

        if (fieldName === "First_Name" && !allDetailData.Last_Name) {
            this.setState({ Last_Name: value });
        }
        this.checkFirstNameAndLastNameLength(value);
    }
    if (this.props.field_api_name === 'First_Name' || this.props.field_api_name === 'Last_Name' || this.props.field_api_name === 'flxLast_Name__c') {
      this.props.fieldChange(this.props.field_api_name, value, this.props.field_type, event, this.state.keyData);
    }
    this.onBlurEvent();
};

onKeyPressAndPasteDataForFirstNameAndLastName = (event) => {
  const pastedText = event.clipboardData.getData('Text').trim();
  const hyphenCount = (pastedText.match(/-/g) || []).length;
  const apostropheCount = (pastedText.match(/'/g) || []).length;

  const pastedValue = event.clipboardData ? event.clipboardData.getData('Text') : null;
  if (event.type === "paste") {
    if (this.props.field_api_name === 'First_Name' || this.props.field_api_name === 'Last_Name' || this.props.field_api_name === 'flxLast_Name__c') {
         this.validateFirstAndLastNamePaste(event,pastedValue,hyphenCount,apostropheCount);
    }

    if(this.props.field_api_name === 'Confirm_Email_Address'){
      if (!/\d/.test(event.clipboardData.getData('Text')) || /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/.test(event.clipboardData.getData('Text')) || event.clipboardData.getData('Text')) {
        event.preventDefault();
      }
    }
  }
};

validateFirstAndLastNamePaste = (event, pastedValue, hyphenCount, apostropheCount) => {

    if (!/^[a-zA-Z-' ]+$/.test(pastedValue) || /\d/.test(pastedValue) || /[~`!@#$%^&*()_+=[\]{};:"\\|,.<>/?]+/.test(pastedValue)) {
      event.preventDefault();
      return false;
    }

    if (hyphenCount > 1 || apostropheCount > 1) {
      event.preventDefault();
      return false;
    }

    if (/^[-']$/.test(pastedValue)) {
      event.preventDefault();
      return false;
    }

    if (pastedValue.includes("-'") || pastedValue.includes("'-")) {
      event.preventDefault();
      return false;
    }

    if (hyphenCount > 1 || apostropheCount > 1) {
      event.preventDefault();
      return false;
    }
  
};

handleDrop = (event) => {
    if (this.props.field_api_name === 'Confirm_Email_Address') {
      const droppedData = event.dataTransfer.getData('text');
      if (!/\d/.test(droppedData) || /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/.test(droppedData)) {
        event.preventDefault();
      }
    }
};

handleBeforeInput = (e) => {
  const nextChar = e.data;
  if (this.props.field_api_name === 'Mobile_Number' || this.props.field_api_name === 'flxpersonmobile__c' || this.props.field_api_name === 'flxNumber_of_Other_Financial_Dependents__c') {
    if (nextChar) {
      let chars = nextChar.split('');
      chars.forEach(char => {
        if (!/^\d$/.test(char) || chars.length > 11) {
          e.preventDefault();
        }
      });
    }
    if(e.target.value.length === 11){
      e.preventDefault();
    }    
  }
};

  onBeforeInputForAddress = (event) => {
    const { field_api_name } = this.props;
    const { value } = event.target;
    const nextChar = event.data;

    const isValidAddress = this.handleAddressQuestionFieldValidation(field_api_name, nextChar, value);
    if (!isValidAddress) {
      event.preventDefault();
      return false;
    }

    this.setState({ keyData: nextChar });
  }; 
  

  getFieldConfigurations(allDetailData, initialDisableValue) {
    let disableValue = initialDisableValue;
    const fieldName = this.props.field_api_name;
    if (fieldName === 'Total_Expenditure__c') {
      disableValue = true;
    }
    if (fieldName === 'Mobile_Number') {
      disableValue = this.props.disableMobileNumberField;
    }
    disableValue = this.residentialFieldDisableCheck(allDetailData, disableValue);
    if (fieldName === 'Email_Address' && this.props.isEmailFieldDisabled) {
      disableValue = true;
    }
    if (fieldName === 'Confirm_Email_Address' && this.props.isConfirmEmailFieldDisabled) {
      disableValue = true;
    }
    const isDependentField = fieldName === 'flxNumber_of_Other_Financial_Dependents__c';
    const minNumber = isDependentField ? 0 : '';
    const maxNumber = isDependentField ? 9 : '';

    return { disableValue, minNumber, maxNumber };
  }


  render() {
    const allDetails = Object.assign({}, ...this.props.applicationValidation);
    const allDetailData = Object.assign({}, ...this.props.saveApplicationData);

    let allowValue = this.state.showDev[this.props.field_api_name];
    this.onBlurEvent();
    allowValue = this.occupationValidation(allowValue);

    allowValue = this.occupationCheck(allowValue)
    let basedisableValue = false
    basedisableValue = this.prepopulateCondition(allDetailData, basedisableValue);
    
    basedisableValue = this.disableNameFieldOnAmending(allDetailData,basedisableValue);
    const{ disableValue,minNumber, maxNumber } = this.getFieldConfigurations(allDetailData, basedisableValue );

    if (allowValue === true &&
  (this.props.field_api_name !== 'Confirm_Email_Address' || (process.env.REACT_APP_ENABLE_CONFIRM_EMAIL_ADDRESS_FIELD == 'true' && this.props.field_api_name === 'Confirm_Email_Address'))) {

      return (

        <React.Fragment>

{this.props.field_api_name == "Fractional_Residential_Expense__c" &&
                
                <span className='step-information'>
                  {this.props.field_fieldinfo}
                </span>
              
}

        {this.props.field_question !== '' && this.props.field_api_name != "Total_Expenditure__c" &&
            <div className={this.classNameForDivElement(this.props)} >
              
              <div className="form-group">
                <div className='d-flex flex-row'>
                  <span>{this.props.field_question}
                  {(this.props.flxQuestionMoreInfo) &&
                    <button className='fieldTip' type="button">
                      <span>
                          <img src="images/humm-infoIcon.svg" alt="humm-logo" />
                          {this.props.flxQuestionMoreInfo}
                      </span>
                      <img src="images/more-info-icon.svg" alt="info-icon" />
                    </button>
                  }
                  </span>
                </div>

                <input type={this.state.inputType} name={this.props.field_api_name} value="" readOnly={true} style={{ display: "none", opacity: 0, position: "absolute" }} autoComplete="off" />

                

                <div className={this.props.field_type === 'Currency' ? 'pound-input' : ''}>
                  {this.props.field_type === 'Currency' && allDetailData[this.props.field_api_name] !== '' && 
                  allDetailData[this.props.field_api_name] !== undefined &&
                    <span className="pound-span">£</span>
                  }
                  <input type={this.state.inputType}
                  min= {minNumber}
                  max={maxNumber}
                  ref={this.inputRef}
                  onWheel={(blurEvent) => { blurEvent.target.blur() }} lang="en" 
                  onKeyPress={(keyPressEvent) => { this.onKeyPressData(keyPressEvent) }} 
                  onKeyDown={(keyDownEvent) => { this.onKeyPressDown(keyDownEvent) }} 
                  onBeforeInput={(e) => {
                    this.handleBeforeInput(e);
                    this.onBeforeInputForAddress(e);
                  }}
                  onInput={(onInputChange) => {this.onInputChange(onInputChange)}}
                  className={this.classNameForInputField(allDetailData, disableValue)} 
                  id={this.props.field_api_name} 
                  name={this.props.field_api_name} 
                  onFocus={this.onFocus}

                    aria-describedby="email"

                    value={allDetailData[this.props.field_api_name] !== '' ? this.state.value : ''}
                    placeholder={this.props.field_placeholder}
                    onChange={
                      (e) => { this.props.fieldChange(this.props.field_api_name, e.target.value, this.props.field_type, e, this.state.keyData); this.handleChange(e) }
                    }
                    disabled = {disableValue}
                    onClick = {(e) => analyticsClickEvent(this.props.field_label,'')}
                    onBlur={(e) => {
                      this.props.onBlurEvent(e, this.state.showInformation, this.state.maxValue, this.props.field_api_name, this.props.field_label);
                      this.handleBlur(e);
                    }}
                    onPaste={(e) => { this.onKeyPressAndPasteDataForFirstNameAndLastName(e) }} onDrop={this.handleDrop} autoCorrect="off" autoCapitalize="none" spellCheck="false"/>
                  {(allDetails[this.props.field_api_name] == "" &&  allDetailData[this.props.field_api_name] !== '' && 
                  allDetailData[this.props.field_api_name] !== undefined)&& 
                    <div className='input-group-append-text'>
                        <span>
                          <img src="images/tick-mark.svg" alt="tick icon for validation" className='validation-tickmark' />
                        </span>
                    </div>
                  }
                </div>
                {/* user name error message */}
                {allDetails[this.props.field_api_name] !== ''&&
                  <p className="error-message"><span className="app-error-message" style={{ color: 'Red' }}>{allDetails[this.props.field_api_name]}</span> </p>
                }

              </div>
            </div>

          }
          {this.props.field_question === '' &&  this.props.field_api_name != "Total_Expenditure__c" &&
            <div className={this.classNameForDivElement(this.props)}>
              <div className="form-group">
                <span></span>

                <input type={this.state.inputType} name={this.props.field_api_name} value="" readOnly={true} style={{ display: "none", opacity: 0, position: "absolute" }} autoComplete="off" />

                <input type={this.state.inputType} min= {minNumber} max={maxNumber} onWheel={(event) => { event.target.blur() }} className={`form-control  ${this.props.field_type === 'Currency' && this.state.value !== '' ? "custom-cat-displays" : ""}`} id="" onFocus={this.onFocus} name={this.props.field_api_name} aria-describedby="email" autoComplete="off" autoCorrect="off" autoCapitalize="none" spellCheck="false"
                  value={this.state.value ? this.state.value.replace(/\D/g, "").split("").reverse().join("")       
    : this.state.value} placeholder={this.props.field_placeholder} onChange={this.handleChange} onClick = {(e) => analyticsClickEvent(this.props.field_label,'')} onPaste={(e) => { this.onlyAcceptInputs(e) }} />
                <p className="error-message">{this.state.errors[this.props.field_api_name] !== '' && this.state.showValidation === 'yes' &&
                  <span className="app-error-message" style={{ color: 'Red' }}>{this.state.errors[this.props.field_api_name]}</span>
                }
                </p>
              </div>
            </div>
          }
        {/* Disabled the Total Expenditure 3244-ID */}
        


        </React.Fragment>
      );
    } else {
      return (
        <></>
      )
    }

  }
}



export const mapStateToProps = (state) => {
  return {
    firstSectionSteps: state.dataStore.firstSectionSteps,
    applicationValidation: state.dataStore.applicationValidation,
    showAppValidations: state.dataStore.showAppValidations,
    emails: state.dataStore.emails,
    confirmemail: state.dataStore.confirmemail,
    saveApplicationData: state.dataStore.saveApplicationData,
    phoneNumbers: state.dataStore.phoneNumbers,
    employmentStatus: state.dataStore.employmentStatus,
    amountRequested: state.dataStore.amountRequested,
    threashold:state.dataStore.threashold,
    questionValueSave:state.dataStore.questionValueSave,
    prepopulateStatus:state.dataStore.prepopulateStatus,
    userDetailsPopulateStatus: state.dataStore.userDetailsPopulateStatus,
    firstNameFlag: state.dataStore.firstNameFlag,
		lastNameFlag: state.dataStore.lastNameFlag,
		emailFlag: state.dataStore.emailFlag,
		mobileNumberFlag: state.dataStore.mobileNumberFlag,
    isMobileVerified: state.dataStore.isMobileVerified,
    isEmailVerified: state.dataStore.isEmailVerified,
    isChangeMobile: state.dataStore.isChangeMobile,
    isChangeEmail: state.dataStore.isChangeEmail,
    secondSectionSteps: state.dataStore.secondSectionSteps,
    fourSectionSteps: state.dataStore.fourSectionSteps,
  };
};


export const mapDispatchToProps = (dispatch) => {
  return {
    appvalidations: (validations) => {
      return dispatch({
        type: "APP_VALIDATIONS",
        value: validations
      });
    },
    firstSectionValidationUpdate: (validations) => {
      return dispatch({
        type: "FIRST_SECTION_STEPS",
        value: validations
      });
    },
    secondSectionValidationUpdate: (validations) => {
      return dispatch({
        type: "SECOND_SECTION_STEPS",
        value: validations
      });
    },
    thirdSectionValidationUpdate: (validations) => {
      return dispatch({
        type: "THIRD_SECTION_STEPS",
        value: validations
      });
    },
    fourSectionValidationUpdate: (validations) => {
      return dispatch({
        type: "FOUR_SECTION_STEPS",
        value: validations
      });
    },
    updateMobileChange: (validations) => {
      return dispatch({
        type: 'SET_MOBILE_CHANGE',
        value: validations
      });
    },
    updateEmailChange: (validations) => {
      return dispatch({
        type: 'SET_EMAIL_CHANGE',
        value: validations
      });
    },
    showappValidation: (validations) => {
      return dispatch({
        type: "SHOW_APP_VALIDATIONS",
        value: validations
      });
    },
    email: (validations) => {
      return dispatch({
        type: 'EMAIL',
        value: validations
      });
    },
    confirmemails: (validations) => {
      return dispatch({
        type: 'CONFIRMEMAIL',
        value: validations
      });
    },
    saveApplicationDatas: (data) => {
      return dispatch({
        type: 'SAVEDATA',
        value: data
      });
    },
    removeApplicationData: (data) => {
      return dispatch({
        type: 'REMOVEDATA',
        value: data
      });
    },
    getPhoneNumber: (validations) => {
      return dispatch({
        type: 'PHONENO',
        value: validations
      });
    },
    getAmountRequested: (validations) => {
      return dispatch({
        type: 'AMOUNTREQUESTED',
        value: validations
      });
    },
    threasholdFunc: (validations) => {
      return dispatch({
        type: 'THREADSHOLD',
        value: validations
      });
    },
    questionSave:(data)=>{
      return dispatch({
        type: 'QUESTIONSAVE',
        value: data
    });
    },

  }
}

Input.propTypes = {
  firstSectionSteps: PropTypes.array,
  showAppValidations: PropTypes.string,
  field_api_name: PropTypes.string,
  stage: PropTypes.string,
  threshold: PropTypes.number,
  field_fieldinfo: PropTypes.string,
  priority: PropTypes.number,
  field_api_validations: PropTypes.array,
  questionSave: PropTypes.func,
  field_type: PropTypes.string,
  field_placeholder: PropTypes.string,
  saveApplicationData: PropTypes.array,
  applicationValidation: PropTypes.array,
  initialLoad: PropTypes.bool,
  employmentStatus: PropTypes.bool,
  onBlurEvent: PropTypes.func,
  threasholdFunc: PropTypes.func,
  fieldChange: PropTypes.func,
  appvalidations: PropTypes.func,
  getAmountRequested: PropTypes.func,
  editable: PropTypes.bool,
  prepopulateStatus: PropTypes.bool,
  firstNameFlag: PropTypes.bool,
  lastNameFlag: PropTypes.bool,
  emailFlag: PropTypes.bool,
  mobileNumberFlag: PropTypes.bool,
  firstSectionValidationUpdate: PropTypes.func,
  secondSectionValidationUpdate: PropTypes.func,
  fourSectionValidationUpdate: PropTypes.func,
  saveApplicationDatas: PropTypes.func,
  field_label: PropTypes.string,
  isChangeEmail: PropTypes.bool,
  isChangeMobile: PropTypes.bool,
  field_value: PropTypes.string,
  flxQuestionMoreInfo: PropTypes.string,
  userDetailsPopulateStatus: PropTypes.bool,
  getPhoneNumber: PropTypes.func,
  isMobileVerified: PropTypes.bool,
  isEmailVerified: PropTypes.bool,
  prepopulateCondition: PropTypes.bool,
  email: PropTypes.func,
  confirmemails: PropTypes.func,
  field_question: PropTypes.string,
  goBackAmendClicked:PropTypes.bool,
  onBlurInputFiled:PropTypes.bool,
  disableMobileNumberField: PropTypes.bool,
  isEmailFieldDisabled: PropTypes.bool,
  isConfirmEmailFieldDisabled: PropTypes.bool,
  thirdSectionValidationUpdate: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(Input)
